function drawSfPrint(ordtype, sfzmjnum, no, rootno, sfprintpagetype, expno, receiveraddr1, receiveraddr2,
  receivername, receivertel, origincode, destcode, destRouteLabel,
      sfexpresstype, sfpaymethod, sellermemo, expcontent, backno, courier, guavalueamount,
      sfcustid, senderaddr1, senderaddr2, sendername, sendertel, orderid, bback, taskId ,idx, expmemo, content, cmpyname, bprintaccount, printmemo){

  //月结账号为"8888888888"时，付款方式改为"寄付现结";
  if (sfcustid == "8888888888") {
    sfpaymethod = "寄付现结";
  }
  if (null != receivertel && receivertel.length > 4) {
    receivertel = receivertel.substr(0,3) + "****" + receivertel.substr(7);
  }

  let twoDimensionCode = content.twoDimensionCode ? unescape(content.twoDimensionCode) : 'MMM={"K1":"","K2":"'+destRouteLabel+'","K3":"","K4":"'+proCode+'","K5":"'+expno+'","K6":"'+content.checkCode+'"}'
  let proCode = content.proCode
  let codingMapping = content.codingMapping
  let printIcon = content.printIcon

  //顺丰热敏新面单打印 yp
  /**---------绘制表格---------**/
  LODOP.SET_SHOW_MODE("NP_NO_RESULT", true);
  LODOP.SET_PRINT_MODE("CATCH_PRINT_STATUS",true);//设置是否进行对后台服务的打印状态进行捕获
  if(sfprintpagetype == 0 || sfprintpagetype == 2){
    //2联 \ 丰密面单 100 * 150
    LODOP.PRINT_INITA("1.5mm","2mm","100mm", "150mm", idx + "SF打印任务" + expno);
    LODOP.SET_PRINT_PAGESIZE(0, "100mm", "150mm", "");//初始化后，设置打印纸张的大小
  } else if (sfprintpagetype == 1 || sfprintpagetype == 4) {
    //3联 \ 丰密面单 100 * 210
    LODOP.PRINT_INITA("1.5mm","2mm", "100mm", "210mm", idx + "SF打印任务" + expno);
    LODOP.SET_PRINT_PAGESIZE(0, "100mm", "210mm", "");
  }else if (sfprintpagetype == 3) {
      //丰密面单 100 * 180
      LODOP.PRINT_INITA("1.5mm","2mm","100mm", "180mm", idx + "SF打印任务" + expno);
      LODOP.SET_PRINT_PAGESIZE(0, "100mm", "180mm", "");//初始化后，设置打印纸张的大小
  }
  LODOP.NewPage();
  //
  if(sfprintpagetype == 0 || sfprintpagetype == 1) {
      //-----第一联---------------------------------------------
      //绘制第一联的矩形框
      LODOP.ADD_PRINT_RECT("2mm", "2mm","96mm","88mm", 0, 1);//增加矩形线

      //画第一联的横线
      LODOP.ADD_PRINT_SHAPE(1, "15mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L1");
      LODOP.ADD_PRINT_SHAPE(1, "35mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L2");
      LODOP.ADD_PRINT_SHAPE(1, "53mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L3");
      LODOP.ADD_PRINT_SHAPE(1, "64mm","68mm","30mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L4");
      LODOP.ADD_PRINT_SHAPE(1, "74mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L5");
      //画第一联的竖线
      LODOP.ADD_PRINT_SHAPE(0, "15mm","72mm",1, "20mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L21");
      LODOP.ADD_PRINT_SHAPE(0, "53mm","68mm",1, "21mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L22");
      LODOP.ADD_PRINT_SHAPE(0, "74mm","56mm",1, "16mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L23");
      LODOP.ADD_PRINT_SHAPE(0, "74mm","77mm",1, "16mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L24");
      //打印log区中的内容
      //打印顺丰logo图片
      // <%-- LODOP.ADD_PRINT_IMAGE("4mm","4mm","20mm","7mm","<img src='<%=OSSUtils.ALIYUN_PATH%>expimg/sflogo.jpg@80w_22h_0e'/>"); --%>
      //打印顺丰电话
      // <%-- LODOP.ADD_PRINT_IMAGE("4mm","76mm","20mm","7mm","<img src='<%=OSSUtils.ALIYUN_PATH%>expimg/sftel.jpg@70w_24h_0e'/>"); --%>
      if (bback != "") {//签单返回业务，打印POD
      LODOP.ADD_PRINT_TEXT("4mm","28mm","30mm","8mm","POD");
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 24);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial");
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);
      }
      else
      {
      LODOP.ADD_PRINT_TEXT("4mm","28mm","70mm","8mm",destRouteLabel);
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 22);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial");
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);
      }
      //打印E标(陆运标识)
      if (sfexpresstype == "电商特惠") {//子母件，头部中间子母件序号
      LODOP.ADD_PRINT_TEXT("0mm","58mm","8mm","15mm","E");
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 48);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);
      }
      //打印条码信息
      LODOP.ADD_PRINT_BARCODE("16mm","5mm","66mm","13mm","128Auto", expno);
      /* //打印快递单号
      LODOP.ADD_PRINT_TEXT("31mm","12mm","45mm","3mm", expno);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial"); */
      //子母单号打印
      if (ordtype == 1) {
      LODOP.ADD_PRINT_TEXT("32mm","4mm","10mm","5mm", no + "/" + sfzmjnum);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

      if (rootno != null && rootno != "") {
          LODOP.ADD_PRINT_TEXT("32mm","13mm","20mm","5mm", "母单号：");
          LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
          LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
          LODOP.ADD_PRINT_TEXT("32mm","26mm","30mm","5mm", rootno);
          LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
          LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial");
      }
      } else {
      LODOP.ADD_PRINT_TEXT("32mm","4mm","10mm","5mm", "1/1");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      }
      //打印业务类型，目的地
      LODOP.ADD_PRINT_TEXT("16mm","74mm","28mm","6mm", sfexpresstype);//业务类型
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      LODOP.ADD_PRINT_TEXT("24mm","73mm","10mm","3mm", "目的地");//目的地
      LODOP.SET_PRINT_STYLEA(0,"FontSize",6);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      //destcode = "111111";
      if(destcode != null && destcode.length > 3){
      LODOP.ADD_PRINT_TEXT("26mm","73mm","30mm","7mm", destcode);//目的地代码
      LODOP.SET_PRINT_STYLEA(0,"FontSize",24 );
      LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial");
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);
      }else {
      LODOP.ADD_PRINT_TEXT("24mm","77mm","30mm","7mm", destcode);//目的地代码
      LODOP.SET_PRINT_STYLEA(0,"FontSize",28);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial");
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);
      }

      //打印收件方信息
      LODOP.ADD_PRINT_TEXT("37mm","4mm","5mm","10mm","收件");//打印收件
      LODOP.SET_PRINT_STYLEA(0,"FontSize",14);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);
      LODOP.SET_PRINT_STYLEA(0,"Vorient",1);
      if(receiveraddr1.length <= 16){
      LODOP.ADD_PRINT_TEXT("36mm","14mm","95mm","7mm",receiveraddr1);//打印省市区
      LODOP.SET_PRINT_STYLEA(0,"FontSize",14);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      }else{
      LODOP.ADD_PRINT_TEXT("36mm","14mm","95mm","7mm",receiveraddr1);//打印省市区
      LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      }
      LODOP.ADD_PRINT_TEXT("41mm","14mm","95mm","5mm",receiveraddr2);//打印详细地址
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.ADD_PRINT_TEXT("49mm","14mm","80mm","3mm",receivername + "  " + receivertel);//打印收件人和收件人地址
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      //打印付费方式及增值服务信息
      //如果保价金额不为空，打印保价声明价值
      if (guavalueamount != null && guavalueamount != "") {
      LODOP.ADD_PRINT_TEXT("54.5mm","4mm","25mm","2.5mm","保价声明价值：");//
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 7);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      LODOP.ADD_PRINT_TEXT("54.5mm","22mm","10mm","2.5mm", guavalueamount);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial");
      LODOP.ADD_PRINT_TEXT("54.5mm","30mm","2.5mm","2.5mm", "元");
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 7);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      LODOP.ADD_PRINT_TEXT("54.5mm","34mm","15mm","2.5mm","保费：");//
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 7);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      }
      //打印付款方式
      LODOP.ADD_PRINT_TEXT("60mm","4mm","30mm","2.5mm","付款方式：" + sfpaymethod);
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 7);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      //打印月结账号
      //jhw-2017-09-14修改  月结账号为"8888888888"时，不打印月结账号;
      if (sfcustid != "8888888888" && bprintaccount == 1){
      LODOP.ADD_PRINT_TEXT("60mm","30mm","13mm","2.5mm","月结账号：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 6);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      LODOP.ADD_PRINT_TEXT("60mm","45mm","25mm","2.5mm", sfcustid);
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 6);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial");
      }

      //打印实际重量
      LODOP.ADD_PRINT_TEXT("65mm","4mm","20mm","2.5mm","实际重量：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 7);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      //打印计费重量
      LODOP.ADD_PRINT_TEXT("65mm","22mm","20mm","2.5mm","计费重量：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 7);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      //打印代收货款
      LODOP.ADD_PRINT_TEXT("54mm","69mm","28mm","5mm","代收货款：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 12);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);
      //打印运费
      LODOP.ADD_PRINT_TEXT("66mm","71mm","20mm","3.5mm","运费：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      //打印费用合计
      LODOP.ADD_PRINT_TEXT("70mm","71mm","20mm","3.5mm","费用合计：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      //打印寄件方信息
      LODOP.ADD_PRINT_TEXT("75mm","3mm","3.5mm","12mm","寄件");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.SET_PRINT_STYLEA(0,"Vorient",1);
      //打印寄件人的省市区
      LODOP.ADD_PRINT_TEXT("75mm","7mm","50mm","7mm", senderaddr1 + " " + senderaddr2);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      //打印寄件人详细地址
      /* LODOP.ADD_PRINT_TEXT("77.5mm","7mm","50mm","5mm", senderaddr2);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体"); */
      //打印寄件人姓名和电话
      LODOP.ADD_PRINT_TEXT("84mm","4mm","50mm","2.5mm", sendername + " " + sendertel);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      /* LODOP.ADD_PRINT_TEXT("84mm","15mm","50mm","2.5mm", sendertel);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","Arial"); */
      //打印原寄地
      LODOP.ADD_PRINT_TEXT("87mm","36mm","15mm","2.5mm", "原寄地：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      LODOP.ADD_PRINT_TEXT("87mm","46mm","10mm","2.5mm", origincode);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial");
      //打印收派信息
      LODOP.ADD_PRINT_TEXT("75mm","57mm","20mm","2.5mm", "收件员");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.ADD_PRINT_TEXT("81mm","57mm","20mm","2.5mm", "寄件日期");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.ADD_PRINT_TEXT("87mm","57mm","20mm","2.5mm", "派件员");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      //打印收方签署信息
      LODOP.ADD_PRINT_TEXT("75mm","81mm","15mm","3mm", "收方签署");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.ADD_PRINT_TEXT("86mm","78mm","12mm","3mm","日期：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      LODOP.ADD_PRINT_TEXT("86mm","88mm","3mm","3mm","月");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      LODOP.ADD_PRINT_TEXT("86mm","95mm","3mm","3mm","日");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      //-----------绘制第二联---------------------------------------
      LODOP.ADD_PRINT_RECT("90mm", "2mm","96mm","58mm", 0, 1);
      //画横线
      LODOP.ADD_PRINT_SHAPE(1, "90mm","2mm","96mm",1,0,2,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L101");
      LODOP.ADD_PRINT_SHAPE(1, "107mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L102");
      LODOP.ADD_PRINT_SHAPE(1, "121mm","44mm","54mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L103");
      LODOP.ADD_PRINT_SHAPE(1, "126mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L104");
      LODOP.ADD_PRINT_SHAPE(1, "138mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L105");
      //画竖线
      LODOP.ADD_PRINT_SHAPE(0, "90mm","44mm",1, "36mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L121");
      LODOP.ADD_PRINT_SHAPE(0, "138mm","82mm",1,"10mm",0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L122");
      //打印顺丰logo图片
      // <%-- LODOP.ADD_PRINT_IMAGE("92mm","4mm","20mm","7mm","<img src='<%=OSSUtils.ALIYUN_PATH%>expimg/sflogo.jpg@80w_22h_0e'/>"); --%>
      //打印顺丰电话
      // <%-- LODOP.ADD_PRINT_IMAGE("92mm","23mm","20mm","7mm","<img src='<%=OSSUtils.ALIYUN_PATH%>expimg/sftel.jpg@70w_24h_0e'/>"); --%>
      //绘制条码信息
      LODOP.ADD_PRINT_BARCODE("92mm","49mm","56mm","13mm","128Auto", expno);
      /* //打印快递单号
      LODOP.ADD_PRINT_TEXT("104mm","48mm","45mm","3mm", expno);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial"); */
      //打印寄件方信息
      LODOP.ADD_PRINT_TEXT("109mm","4mm","3mm","12mm","寄件");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.SET_PRINT_STYLEA(0,"Vorient",1);
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);
      //打印寄件人的省市区
      LODOP.ADD_PRINT_TEXT("108mm","7mm","40mm","7mm", senderaddr1 + " " + senderaddr2);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      //打印寄件人详细地址
      /* LODOP.ADD_PRINT_TEXT("110.5mm","7mm","40mm","5mm", senderaddr2);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体"); */
      //打印寄件人姓名和电话
      LODOP.ADD_PRINT_TEXT("118mm","7mm","25mm","2.5mm", sendername);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.ADD_PRINT_TEXT("120.5mm","4mm","50mm","2.5mm", sendertel);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","Arial");
      //打印收件信息
      LODOP.ADD_PRINT_TEXT("109mm","46mm","3mm","7mm","收件");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.SET_PRINT_STYLEA(0,"Vorient",1);
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);
      //打印收件人的地址
      LODOP.ADD_PRINT_TEXT("108mm","51mm","48mm","7mm", receiveraddr1+" "+receiveraddr2);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      //打印收件人姓名和电话
      LODOP.ADD_PRINT_TEXT("116mm","46mm","50mm","2.5mm", receivername + " " +receivertel);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      /* LODOP.ADD_PRINT_TEXT("116mm","57mm","50mm","2.5mm", receivertel);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","Arial"); */
      //打印寄件日期
      LODOP.ADD_PRINT_TEXT("119mm","46mm","20mm","2.5mm", "寄件日期：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      //打印订单号
      LODOP.ADD_PRINT_TEXT("122mm","46mm","15mm","2.5mm","订单号：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.ADD_PRINT_TEXT("122mm","60mm","35mm","2.5mm", orderid);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      //打印托寄物
      if(expcontent.length <= 19){
          LODOP.ADD_PRINT_TEXT("129mm","4mm","15mm","2.5mm","托寄物");
          LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
          LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
          LODOP.ADD_PRINT_TEXT("129mm","15mm","80mm","9mm", expcontent);
          LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
          LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      }else{
          LODOP.ADD_PRINT_TEXT("129mm","4mm","15mm","2.5mm","托寄物");
          LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
          LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
          LODOP.ADD_PRINT_TEXT("129mm","15mm","80mm","9mm", expcontent);
          LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
          LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      }

      //打印备注
      let meno ='' // 最终打印备注

      if (((sellermemo?sellermemo.length:0) + (printmemo?printmemo.length:0) )> 40) {
        sellermemo = sellermemo ? (sellermemo.substring(0,(40 - printmemo.length - 4)) + '...') : ''
      } else {
        sellermemo = sellermemo?sellermemo:''
      }
      meno = sellermemo + ' ' + (printmemo?printmemo:'')
      console.log('两联单',sellermemo,printmemo)
      LODOP.ADD_PRINT_TEXT("140mm","4mm","10mm","2.5mm","备注");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.ADD_PRINT_TEXT("140mm","12mm","70mm","8mm", meno);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      //打印费用合计
      LODOP.ADD_PRINT_TEXT("140mm","83mm","20mm","2.5mm","费用合计：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");


      /*

      if (backno != null && backno != "") {
      LODOP.ADD_PRINT_TEXT("75.5mm","1mm","20mm","4mm","签回单号：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 7);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      LODOP.ADD_PRINT_TEXT("75.5mm","15mm","25mm","4mm", backno);
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 7);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial");
      } */
      if (sfprintpagetype == 1) {
          //-------------第三联------------------------------------
          LODOP.ADD_PRINT_RECT("148mm", "2mm","96mm","58mm", 0, 1);
          //画横线
          LODOP.ADD_PRINT_SHAPE(1, "148mm","2mm","96mm",1,0,2,"#000000");
          LODOP.SET_PRINT_STYLEA(0,"ItemName","L101");
          LODOP.ADD_PRINT_SHAPE(1, "165mm","2mm","96mm",1,0,1,"#000000");
          LODOP.SET_PRINT_STYLEA(0,"ItemName","L102");
          LODOP.ADD_PRINT_SHAPE(1, "179mm","44mm","54mm",1,0,1,"#000000");
          LODOP.SET_PRINT_STYLEA(0,"ItemName","L103");
          LODOP.ADD_PRINT_SHAPE(1, "184mm","2mm","96mm",1,0,1,"#000000");
          LODOP.SET_PRINT_STYLEA(0,"ItemName","L104");
          LODOP.ADD_PRINT_SHAPE(1, "196mm","2mm","96mm",1,0,1,"#000000");
          LODOP.SET_PRINT_STYLEA(0,"ItemName","L105");
          //画竖线
          LODOP.ADD_PRINT_SHAPE(0, "148mm","44mm",1, "36mm",0,1,"#000000");//|线
          LODOP.SET_PRINT_STYLEA(0,"ItemName","L121");
          LODOP.ADD_PRINT_SHAPE(0, "196mm","82mm",1,"10mm",0,1,"#000000");
          LODOP.SET_PRINT_STYLEA(0,"ItemName","L122");
          //打印顺丰logo图片
          // <%-- LODOP.ADD_PRINT_IMAGE("150mm","4mm","20mm","7mm","<img src='<%=OSSUtils.ALIYUN_PATH%>expimg/sflogo.jpg@80w_22h_0e'/>"); --%>
          //打印顺丰电话
          // <%-- LODOP.ADD_PRINT_IMAGE("150mm","23mm","20mm","7mm","<img src='<%=OSSUtils.ALIYUN_PATH%>expimg/sftel.jpg@70w_24h_0e'/>"); --%>
          //绘制条码信息
          LODOP.ADD_PRINT_BARCODE("150mm","49mm","56mm","13mm","128Auto", expno);
          /* //打印快递单号
          LODOP.ADD_PRINT_TEXT("104mm","48mm","45mm","3mm", expno);
          LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
          LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial"); */
          //打印寄件方信息
          LODOP.ADD_PRINT_TEXT("167mm","4mm","3mm","12mm","寄件");
          LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
          LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
          LODOP.SET_PRINT_STYLEA(0,"Vorient",1);
          LODOP.SET_PRINT_STYLEA(0,"Bold",1);
          //打印寄件人的省市区
          LODOP.ADD_PRINT_TEXT("166mm","7mm","40mm","7mm", senderaddr1 + " " +senderaddr2);
          LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
          LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
          //打印寄件人详细地址
          /* LODOP.ADD_PRINT_TEXT("168.5mm","7mm","40mm","5mm", senderaddr2);
          LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
          LODOP.SET_PRINT_STYLEA(0,"FontName","黑体"); */
          //打印寄件人姓名和电话
          LODOP.ADD_PRINT_TEXT("176mm","7mm","25mm","2.5mm", sendername);
          LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
          LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
          LODOP.ADD_PRINT_TEXT("178.5mm","4mm","50mm","2.5mm", sendertel);
          LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
          LODOP.SET_PRINT_STYLEA(0,"FontName","Arial");
          //打印收件信息
          LODOP.ADD_PRINT_TEXT("167mm","46mm","3mm","7mm","收件");
          LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
          LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
          LODOP.SET_PRINT_STYLEA(0,"Vorient",1);
          LODOP.SET_PRINT_STYLEA(0,"Bold",1);
          //打印收件人的地址
          LODOP.ADD_PRINT_TEXT("166mm","51mm","48mm","7mm", receiveraddr1+" "+receiveraddr2);
          LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
          LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
          //打印收件人姓名和电话
          LODOP.ADD_PRINT_TEXT("174mm","46mm","50mm","2.5mm", receivername + " " + receivertel);
          LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
          LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
          /* LODOP.ADD_PRINT_TEXT("174mm","57mm","50mm","2.5mm", receivertel);
          LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
          LODOP.SET_PRINT_STYLEA(0,"FontName","Arial"); */
          //打印寄件日期
          LODOP.ADD_PRINT_TEXT("177mm","46mm","20mm","2.5mm", "寄件日期：");
          LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
          LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
          //打印订单号
          LODOP.ADD_PRINT_TEXT("180mm","46mm","15mm","2.5mm","订单号：");
          LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
          LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
          LODOP.ADD_PRINT_TEXT("180mm","60mm","35mm","2.5mm", orderid);
          LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
          LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
          //打印托寄物
          if(expcontent <= 20){
              LODOP.ADD_PRINT_TEXT("187mm","4mm","15mm","2.5mm","托寄物");
              LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
              LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
              LODOP.ADD_PRINT_TEXT("187mm","15mm","80mm","9mm", expcontent);
              LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
              LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
          } else {
              LODOP.ADD_PRINT_TEXT("187mm","4mm","15mm","2.5mm","托寄物");
              LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
              LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
              LODOP.ADD_PRINT_TEXT("187mm","15mm","80mm","9mm", expcontent);
              LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
              LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
          }

          //打印备注
          let meno ='' // 最终打印备注
          if (((sellermemo?sellermemo.length:0) + (printmemo?printmemo.length:0) )> 40) {
            sellermemo = sellermemo ? (sellermemo.substring(0,(40 - printmemo.length - 4)) + '...') : ''
          } else {
            sellermemo = sellermemo?sellermemo:''
          }
          meno = sellermemo + ' ' + (printmemo?printmemo:'')
          LODOP.ADD_PRINT_TEXT("198mm","4mm","10mm","2.5mm","备注");
          LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
          LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
          LODOP.ADD_PRINT_TEXT("198mm","12mm","70mm","8mm", meno);
          LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
          LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
          //打印费用合计
          LODOP.ADD_PRINT_TEXT("198mm","83mm","20mm","2.5mm","费用合计：");
          LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
          LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      }
      //寄件方备注
      if(expmemo != null && expmemo != ""){
      LODOP.ADD_PRINT_TEXT("95.99mm","2.01mm","41.99mm","7.01mm",expmemo);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",13);
      LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
      /* LODOP.SET_PRINT_STYLEA(0,"Bold",1); */
      }
  } else if (sfprintpagetype == 2) {
      //丰密面单 100 * 150
      console.log('绘制丰密面单-100*150')
      //绘制第一联的矩形框
      LODOP.ADD_PRINT_RECT("13mm", "2mm","96mm","135mm", 0, 1);//增加矩形线

      //画第一联的横线
      LODOP.ADD_PRINT_SHAPE(1, "35mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L1");
      LODOP.ADD_PRINT_SHAPE(1, "63mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L2");
      LODOP.ADD_PRINT_SHAPE(1, "68mm","2mm","33mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L3");
      LODOP.ADD_PRINT_SHAPE(1, "79mm","77mm","21mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L4");
      LODOP.ADD_PRINT_SHAPE(1, "94mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L5");
      LODOP.ADD_PRINT_SHAPE(1, "105mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L6");
      LODOP.ADD_PRINT_SHAPE(1, "118mm","50mm","48mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L7");
      LODOP.ADD_PRINT_SHAPE(1, "131mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L8");
      //画第一联的竖线
      LODOP.ADD_PRINT_SHAPE(0, "63mm","35mm",1, "31mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L21");
      LODOP.ADD_PRINT_SHAPE(0, "63mm","67mm",1, "31mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L22");
      LODOP.ADD_PRINT_SHAPE(0, "63mm","77mm",1, "31mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L23");
      LODOP.ADD_PRINT_SHAPE(0, "105mm","50mm",1, "43mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L24");

      //顺丰logo
      LODOP.ADD_PRINT_IMAGE("2mm","2mm","30mm","8mm","<img src='../../static/sf_image/logo.png'/>")
      //打印顺丰电话
      LODOP.ADD_PRINT_IMAGE("2mm","76mm","20mm","8mm","<img src='../../static/sf_image/%E7%83%AD%E7%BA%BF.png'/>")

      //条码
      LODOP.ADD_PRINT_BARCODE("15mm","7mm","70mm","15mm","128Auto", expno);
      //子母单号打印
      if (ordtype == 1) {
          LODOP.ADD_PRINT_TEXT("30mm","5mm","10mm","5mm", no + "/" + sfzmjnum);
          LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
          LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

          if (rootno != null && rootno != "") {
              LODOP.ADD_PRINT_TEXT("30mm","13mm","20mm","5mm", "母单号：");
              LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
              LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
              LODOP.ADD_PRINT_TEXT("30mm","26mm","40mm","5mm", rootno);
              LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
              LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial");
          }
      } else {
          LODOP.ADD_PRINT_TEXT("30mm","5mm","10mm","5mm", "1/1");
          LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
          LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      }

      //时效类型
      if(proCode == 'T1') {
          LODOP.ADD_PRINT_IMAGE("15mm","82mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T1.png'/>")
      } else if (proCode == 'T4') {
          LODOP.ADD_PRINT_IMAGE("15mm","82mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T4.png'/>")
      } else if (proCode == 'T8') {
          LODOP.ADD_PRINT_IMAGE("15mm","82mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T8.png'/>")
      } else if (proCode == 'T77') {
          LODOP.ADD_PRINT_IMAGE("15mm","80mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T77.png'/>")
      } else if (proCode == 'T5') {
          LODOP.ADD_PRINT_IMAGE("15mm","82mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T5.png'/>")
      } else if (proCode == 'T29') {
          LODOP.ADD_PRINT_IMAGE("15mm","80mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T29.png'/>")
      } else if (proCode == 'T9') {
          LODOP.ADD_PRINT_IMAGE("15mm","82mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T9.png'/>")
      } else {
          LODOP.ADD_PRINT_IMAGE("15mm","82mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T6.png'/>")
      }

      //目的地
      LODOP.ADD_PRINT_TEXT("36mm","4mm","100mm","12mm",destRouteLabel);
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 30);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial");
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);

      //收方信息
      LODOP.ADD_PRINT_IMAGE("50mm","3mm","8mm","8mm","<img src='../../static/sf_image/%E6%94%B6%EF%BC%887mm%EF%BC%89.png'/>")
      LODOP.ADD_PRINT_TEXT("49mm","12mm","65mm","4mm",receivername + "  " + receivertel)
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9)
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体")
      LODOP.ADD_PRINT_TEXT("54mm","12mm","65mm","10mm",receiveraddr1 + "  " + receiveraddr2)
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9)
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体")

      //代收货款
      //LODOP.ADD_PRINT_IMAGE("46mm","78mm","17mm","9mm","<img src='../../static/sf_image/COD.jpg?x-oss-process=image/resize,m_fixed,w_60'/>")

      //付款方式
      LODOP.ADD_PRINT_TEXT("64mm","2mm","33mm","5mm", sfpaymethod + " " + ( bprintaccount == 1 ? sfcustid : ''));
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

      //进港信息
      LODOP.ADD_PRINT_TEXT("72mm","5mm","30mm","18mm", codingMapping);
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 40);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);

      //二维码
      LODOP.ADD_PRINT_BARCODE("64.27mm","36.62mm",168,146,"QRCode", twoDimensionCode);
      LODOP.SET_PRINT_STYLEA(0,"QRCodeErrorLevel","L");

      //出港信息

      //已验视
      LODOP.ADD_PRINT_TEXT("63mm","69mm","6mm","22mm", "已验视");
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 19);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);

      //寄方信息
      LODOP.ADD_PRINT_IMAGE("96mm","3mm","8mm","8mm","<img src='../../static/sf_image/%E5%AF%84%287mm%29.png'/>")
      LODOP.ADD_PRINT_TEXT("95.5mm","12mm","90mm","3mm",sendername + "  " + sendertel + "  " + cmpyname);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.ADD_PRINT_TEXT("98.5mm","12mm","90mm","5mm",senderaddr1 + "  " + senderaddr2);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");

      //托寄物
      LODOP.ADD_PRINT_TEXT("107mm","4mm","50mm","23mm", "托寄物：" + expcontent);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");

      //增值服务
      let guavalue = "";
      if (guavalueamount != null && guavalueamount != "") {
          guavalue = "保价声明价值：" + guavalueamount + "元；保费："
      }
      LODOP.ADD_PRINT_TEXT("107mm","52mm","45mm","12mm", "增值服务：" + guavalue);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");

      //其他信息
      //打印实际重量
      LODOP.ADD_PRINT_TEXT("119mm","52mm","20mm","3mm","实际重量：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      //打印计费重量
      LODOP.ADD_PRINT_TEXT("119mm","74mm","20mm","3mm","计费重量：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      //打印费用合计
      LODOP.ADD_PRINT_TEXT("123mm","52mm","20mm","3.5mm","费用合计：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      //付款方式
      LODOP.ADD_PRINT_TEXT("127mm","52mm","45mm","3.5mm","付款方式：" + sfpaymethod);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

      //客户自定义区
      let meno ='' // 最终打印备注
      let tmpStr = (sellermemo?sellermemo:'')+' '+(expmemo?expmemo:'')
      let printmemoLength = printmemo?printmemo.length:0
      if (tmpStr&&((tmpStr.length+printmemoLength)> 40)) {
        meno = (tmpStr.substring(0, 40-(printmemo?printmemo.length:0)-4))+'...'+' '+(printmemo?printmemo:'')
      } else {
        let tmpResult1 = (tmpStr?tmpStr:'')+ ' ' +(printmemo?printmemo:'')
        let tmpResult2 = printmemo?printmemo:''
        meno = tmpStr?tmpResult1:tmpResult2
      }

      LODOP.ADD_PRINT_TEXT("133mm","4mm","50mm","20mm", meno);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");

      //图标区域
      let data = '';
      for(let i=0;i<printIcon.length;i++) {
          if(printIcon[i] == '1' && i < 6) {
              data += "<img src='../../static/sf_image/21_21_"+i+".png'/>"
          }
      }
      LODOP.ADD_PRINT_IMAGE("132mm","52mm","45mm","20mm",data)

  } else if (sfprintpagetype == 3) {
      //丰密面单 100 * 180
      console.log('绘制丰密面单-100*180')
      //绘制第一联的矩形框
      LODOP.ADD_PRINT_RECT("13mm", "2mm","96mm","92mm", 0, 1);//增加矩形线
      LODOP.ADD_PRINT_RECT("110mm", "2mm","96mm","65mm", 0, 1);//增加矩形线

      //画第一联的横线
      LODOP.ADD_PRINT_SHAPE(1, "37mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L1");
      LODOP.ADD_PRINT_SHAPE(1, "73mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L2");
      LODOP.ADD_PRINT_SHAPE(1, "81mm","2mm","33mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L3");
      LODOP.ADD_PRINT_SHAPE(1, "94mm","77mm","21mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L4");
      LODOP.ADD_PRINT_SHAPE(1, "122mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L6");
      LODOP.ADD_PRINT_SHAPE(1, "135mm","50mm","48mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L7");
      LODOP.ADD_PRINT_SHAPE(1, "148mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L8");
      //画第一联的竖线
      LODOP.ADD_PRINT_SHAPE(0, "73mm","35mm",1, "32mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L21");
      LODOP.ADD_PRINT_SHAPE(0, "73mm","67mm",1, "32mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L22");
      LODOP.ADD_PRINT_SHAPE(0, "73mm","77mm",1, "32mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L23");
      LODOP.ADD_PRINT_SHAPE(0, "122mm","50mm",1, "53mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L24");

      //顺丰logo
      LODOP.ADD_PRINT_IMAGE("1mm","2mm","30mm","9mm","<img src='../../static/sf_image/logo.png'/>")
      //打印顺丰电话
      LODOP.ADD_PRINT_IMAGE("1mm","76mm","22mm","8mm","<img src='../../static/sf_image/%E7%83%AD%E7%BA%BF.png'/>")

      //条码
      LODOP.ADD_PRINT_BARCODE("15mm","6mm","70mm","15mm","128Auto", expno);
      //子母单号打印
      if (ordtype == 1) {
          LODOP.ADD_PRINT_TEXT("30mm","10mm","10mm","5mm", no + "/" + sfzmjnum);
          LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
          LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

          if (rootno != null && rootno != "") {
              LODOP.ADD_PRINT_TEXT("30mm","15mm","20mm","5mm", "母单号：");
              LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
              LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
              LODOP.ADD_PRINT_TEXT("30mm","28mm","30mm","5mm", rootno);
              LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
              LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial");
          }
      } else {
          LODOP.ADD_PRINT_TEXT("30mm","10mm","10mm","5mm", "1/1");
          LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
          LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      }

      //时效类型
      if(proCode == 'T1') {
          LODOP.ADD_PRINT_IMAGE("15mm","82mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T1.png'/>")
      } else if (proCode == 'T4') {
          LODOP.ADD_PRINT_IMAGE("15mm","82mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T4.png'/>")
      } else if (proCode == 'T8') {
          LODOP.ADD_PRINT_IMAGE("15mm","82mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T8.png'/>")
      } else if (proCode == 'T77') {
          LODOP.ADD_PRINT_IMAGE("15mm","80mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T77.png'/>")
      } else if (proCode == 'T5') {
          LODOP.ADD_PRINT_IMAGE("15mm","82mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T5.png'/>")
      } else if (proCode == 'T29') {
          LODOP.ADD_PRINT_IMAGE("15mm","80mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T29.png'/>")
      } else if (proCode == 'T9') {
          LODOP.ADD_PRINT_IMAGE("15mm","82mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T9.png'/>")
      } else {
          LODOP.ADD_PRINT_IMAGE("15mm","82mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T6.png'/>")
      }

      //目的地
      LODOP.ADD_PRINT_TEXT("38mm","4mm","100mm","12mm",destRouteLabel);
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 30);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial");
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);

      //收方信息
      LODOP.ADD_PRINT_IMAGE("55mm","3mm","8mm","8mm","<img src='../../static/sf_image/%E6%94%B6%EF%BC%887mm%EF%BC%89.png'/>")
      LODOP.ADD_PRINT_TEXT("52mm","12mm","65mm","4mm",receivername + "  " + receivertel)
      // LODOP.SET_PRINT_STYLEA(0,"FontSize",9)
      // LODOP.SET_PRINT_STYLEA(0,"FontName","Arial")
      // LODOP.ADD_PRINT_TEXT("57mm","12mm","65mm","4mm",cmpyname)
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9)
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体")
      LODOP.ADD_PRINT_TEXT("62mm","12mm","65mm","10mm",receiveraddr1 + "  " + receiveraddr2)
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9)
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体")

      //代收货款
      //LODOP.ADD_PRINT_IMAGE("55mm","78mm","17mm","9mm","<img src='../../static/sf_image/COD.jpg?x-oss-process=image/resize,m_fixed,w_60'/>")

      //付款方式
      LODOP.ADD_PRINT_TEXT("75mm","2mm","33mm","5mm", sfpaymethod + " " + ( bprintaccount == 1 ? sfcustid : ''));
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 9);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

      //进港信息
      LODOP.ADD_PRINT_TEXT("83mm","8mm","30mm","18mm", codingMapping);
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 40);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);

      //二维码
      LODOP.ADD_PRINT_BARCODE("75mm","36mm",168,146,"QRCode", twoDimensionCode);
      LODOP.SET_PRINT_STYLEA(0,"QRCodeErrorLevel","L");

      //出港信息

      //已验视
      LODOP.ADD_PRINT_TEXT("74mm","69mm","6mm","23mm", "已验视");
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 20);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);

      //顺丰logo
      LODOP.ADD_PRINT_IMAGE("110mm","2mm","20mm","6mm","<img src='../../static/sf_image/logo.png'/>")
      //打印顺丰电话
      LODOP.ADD_PRINT_IMAGE("116mm","2mm","20mm","6mm","<img src='../../static/sf_image/%E7%83%AD%E7%BA%BF.png'/>")


      //寄方信息
      LODOP.ADD_PRINT_IMAGE("111mm","23mm","8mm","8mm","<img src='../../static/sf_image/%E5%AF%84%287mm%29.png'/>")
      LODOP.ADD_PRINT_TEXT("110.5mm","33mm","65mm","3mm",sendername + "  " + sendertel + "  " + cmpyname);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.ADD_PRINT_TEXT("114mm","33mm","65mm","5mm",senderaddr1 + "  " + senderaddr2);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");

      //托寄物
      LODOP.ADD_PRINT_TEXT("123mm","4mm","50mm","23mm", "托寄物：" + expcontent);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");

      //增值服务
      let guavalue = "";
      if (guavalueamount != null && guavalueamount != "") {
          guavalue = "保价声明价值：" + guavalueamount + "元；保费："
      }
      LODOP.ADD_PRINT_TEXT("123mm","52mm","45mm","12mm", "增值服务：" + guavalue);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");

      //其他信息
      //打印实际重量
      LODOP.ADD_PRINT_TEXT("136mm","52mm","20mm","3mm","实际重量：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      //打印计费重量
      LODOP.ADD_PRINT_TEXT("136mm","74mm","20mm","3mm","计费重量：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      //打印费用合计
      LODOP.ADD_PRINT_TEXT("139.5mm","52mm","20mm","3.5mm","费用合计：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      //付款方式
      LODOP.ADD_PRINT_TEXT("144mm","52mm","45mm","3.5mm","付款方式：" + sfpaymethod);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

      //客户自定义区
      let meno ='' // 最终打印备注
      let tmpStr = (sellermemo?sellermemo:'')+' '+(expmemo?expmemo:'')
      let printmemoLength = printmemo?printmemo.length:0
      if (tmpStr&&((tmpStr.length+printmemoLength)> 40)) {
        meno = (tmpStr.substring(0, 40-(printmemo?printmemo.length:0)-4))+'...'+' '+(printmemo?printmemo:'')
      } else {
        let tmpResult1 = (tmpStr?tmpStr:'')+ ' ' +(printmemo?printmemo:'')
        let tmpResult2 = printmemo?printmemo:''
        meno = tmpStr?tmpResult1:tmpResult2
      }

      LODOP.ADD_PRINT_TEXT("150mm","4mm","50mm","20mm", meno);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");

      //图标区域
      let data = '';
      for(let i=0;i<printIcon.length;i++) {
          if(printIcon[i] == '1' && i < 6) {
              data += "<img src='../../static/sf_image/21_21_"+i+".png'/>"
          }
      }
      LODOP.ADD_PRINT_IMAGE("150mm","52mm","45mm","20mm",data)

  } else if (sfprintpagetype == 4) {
      //丰密面单 100 * 210
      console.log('绘制丰密面单-100*210')
      //绘制第一联的矩形框
      LODOP.ADD_PRINT_RECT("13mm", "2mm","96mm","135mm", 0, 1);//增加矩形线
      LODOP.ADD_PRINT_RECT("150mm", "2mm","96mm","58mm", 0, 1);//增加矩形线

      //画第一联的横线
      LODOP.ADD_PRINT_SHAPE(1, "35mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L1");
      LODOP.ADD_PRINT_SHAPE(1, "63mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L2");
      LODOP.ADD_PRINT_SHAPE(1, "68mm","2mm","33mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L3");
      LODOP.ADD_PRINT_SHAPE(1, "79mm","77mm","21mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L4");
      LODOP.ADD_PRINT_SHAPE(1, "89mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L5");
      LODOP.ADD_PRINT_SHAPE(1, "100mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L6");
      LODOP.ADD_PRINT_SHAPE(1, "113mm","50mm","48mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L7");
      LODOP.ADD_PRINT_SHAPE(1, "126mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L8");
      LODOP.ADD_PRINT_SHAPE(1, "167mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L9");
      LODOP.ADD_PRINT_SHAPE(1, "176mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L10");
      LODOP.ADD_PRINT_SHAPE(1, "185mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L11");
      LODOP.ADD_PRINT_SHAPE(1, "203mm","2mm","96mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L12");
      LODOP.ADD_PRINT_SHAPE(1, "197mm","2mm","31mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L13");
      LODOP.ADD_PRINT_SHAPE(1, "153mm","84mm","14mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L14");
      LODOP.ADD_PRINT_SHAPE(1, "158mm","84mm","14mm",1,0,1,"#000000");
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L15");
      //画第一联的竖线
      LODOP.ADD_PRINT_SHAPE(0, "63mm","35mm",1, "26mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L21");
      LODOP.ADD_PRINT_SHAPE(0, "63mm","67mm",1, "26mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L22");
      LODOP.ADD_PRINT_SHAPE(0, "63mm","77mm",1, "26mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L23");
      LODOP.ADD_PRINT_SHAPE(0, "100mm","50mm",1, "48mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L24");
      LODOP.ADD_PRINT_SHAPE(0, "185mm","33mm",1, "18mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L25");
      LODOP.ADD_PRINT_SHAPE(0, "203mm","19mm",1, "5mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L26");
      LODOP.ADD_PRINT_SHAPE(0, "203mm","41mm",1, "5mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L27");
      LODOP.ADD_PRINT_SHAPE(0, "153mm","84mm",1, "14mm",0,1,"#000000");//|线
      LODOP.SET_PRINT_STYLEA(0,"ItemName","L28");

      //顺丰logo
      LODOP.ADD_PRINT_IMAGE("2mm","2mm","30mm","8mm","<img src='../../static/sf_image/logo.png'/>")
      //打印顺丰电话
      LODOP.ADD_PRINT_IMAGE("2mm","76mm","20mm","8mm","<img src='../../static/sf_image/%E7%83%AD%E7%BA%BF.png'/>")

      //条码
      LODOP.ADD_PRINT_BARCODE("15mm","5mm","66mm","14mm","128Auto", expno);
      //子母单号打印
      if (ordtype == 1) {
          LODOP.ADD_PRINT_TEXT("30mm","5mm","10mm","5mm", no + "/" + sfzmjnum);
          LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
          LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

          if (rootno != null && rootno != "") {
              LODOP.ADD_PRINT_TEXT("30mm","13mm","20mm","5mm", "母单号：");
              LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
              LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
              LODOP.ADD_PRINT_TEXT("30mm","26mm","40mm","5mm", rootno);
              LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
              LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial");
          }
      } else {
          LODOP.ADD_PRINT_TEXT("30mm","5mm","10mm","5mm", "1/1");
          LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
          LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      }

      //时效类型
      if(proCode == 'T1') {
          LODOP.ADD_PRINT_IMAGE("15mm","82mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T1.png'/>")
      } else if (proCode == 'T4') {
          LODOP.ADD_PRINT_IMAGE("15mm","82mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T4.png'/>")
      } else if (proCode == 'T8') {
          LODOP.ADD_PRINT_IMAGE("15mm","82mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T8.png'/>")
      } else if (proCode == 'T77') {
          LODOP.ADD_PRINT_IMAGE("15mm","80mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T77.png'/>")
      } else if (proCode == 'T5') {
          LODOP.ADD_PRINT_IMAGE("15mm","82mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T5.png'/>")
      } else if (proCode == 'T29') {
          LODOP.ADD_PRINT_IMAGE("15mm","80mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T29.png'/>")
      } else if (proCode == 'T9') {
          LODOP.ADD_PRINT_IMAGE("15mm","82mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T9.png'/>")
      } else {
          LODOP.ADD_PRINT_IMAGE("15mm","82mm","15mm","20mm","<img src='../../static/sf_image/20_20%20T6.png'/>")
      }

      //目的地
      LODOP.ADD_PRINT_TEXT("36mm","4mm","100mm","12mm",destRouteLabel);
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 30);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial");
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);

      //收方信息
      LODOP.ADD_PRINT_IMAGE("50mm","3mm","8mm","8mm","<img src='../../static/sf_image/%E6%94%B6%EF%BC%887mm%EF%BC%89.png'/>")
      LODOP.ADD_PRINT_TEXT("49mm","12mm","65mm","4mm",receivername + "  " + receivertel)
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9)
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体")
      LODOP.ADD_PRINT_TEXT("54mm","12mm","65mm","10mm",receiveraddr1 + "  " + receiveraddr2)
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9)
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体")

      //代收货款
      //LODOP.ADD_PRINT_IMAGE("46mm","78mm","17mm","9mm","<img src='../../static/sf_image/COD.jpg?x-oss-process=image/resize,m_fixed,w_60'/>")

      //付款方式
      LODOP.ADD_PRINT_TEXT("64mm","2mm","33mm","5mm", sfpaymethod + " " + ( bprintaccount == 1 ? sfcustid : ''));
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 9);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

      //进港信息
      LODOP.ADD_PRINT_TEXT("72mm","5mm","30mm","18mm", codingMapping);
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 40);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);

      //二维码
      LODOP.ADD_PRINT_BARCODE("64mm","38mm","25mm","25mm","QRCode", twoDimensionCode);
      LODOP.SET_PRINT_STYLEA(0,"QRCodeErrorLevel","L");

      //出港信息

      //已验视
      LODOP.ADD_PRINT_TEXT("63mm","69mm","6mm","22mm", "已验视");
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 19);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);

      //寄方信息
      LODOP.ADD_PRINT_IMAGE("91mm","3mm","8mm","8mm","<img src='../../static/sf_image/%E5%AF%84%287mm%29.png'/>")
      LODOP.ADD_PRINT_TEXT("89.5mm","12mm","88mm","3mm",sendername + "  " + sendertel + "  " + cmpyname);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.ADD_PRINT_TEXT("92.8mm","12mm","88mm","5mm",senderaddr1 + "  " + senderaddr2);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");

      //托寄物
      LODOP.ADD_PRINT_TEXT("102mm","4mm","50mm","23mm", "托寄物：" + expcontent);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");

      //增值服务
      let guavalue = "";
      if (guavalueamount != null && guavalueamount != "") {
          guavalue = "保价声明价值：" + guavalueamount + "元；保费："
      }
      LODOP.ADD_PRINT_TEXT("102mm","52mm","45mm","12mm", "增值服务：" + guavalue);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");

      //其他信息
      //打印实际重量
      LODOP.ADD_PRINT_TEXT("114mm","52mm","20mm","3mm","实际重量：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      //打印计费重量
      LODOP.ADD_PRINT_TEXT("114mm","74mm","20mm","3mm","计费重量：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize", 8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      //打印费用合计
      LODOP.ADD_PRINT_TEXT("118mm","52mm","20mm","3.5mm","费用合计：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      //付款方式
      LODOP.ADD_PRINT_TEXT("122mm","52mm","45mm","3.5mm","付款方式：" + sfpaymethod);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

      //客户自定义区
      let meno ='' // 最终打印备注
      let tmpStr = (sellermemo?sellermemo:'')+' '+(expmemo?expmemo:'')
      let printmemoLength = printmemo?printmemo.length:0
      if (tmpStr&&((tmpStr.length+printmemoLength)> 40)) {
        meno = (tmpStr.substring(0, 40-(printmemo?printmemo.length:0)-4))+'...'+' '+(printmemo?printmemo:'')
      } else {
        let tmpResult1 = (tmpStr?tmpStr:'')+ ' ' +(printmemo?printmemo:'')
        let tmpResult2 = printmemo?printmemo:''
        meno = tmpStr?tmpResult1:tmpResult2
      }

      LODOP.ADD_PRINT_TEXT("128mm","4mm","50mm","20mm", meno);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");

      //图标区域
      let data = '';
      for(let i=0;i<printIcon.length;i++) {
          if(printIcon[i] == '1' && i < 6) {
              data += "<img src='../../static/sf_image/21_21_"+i+".png'/>"
          }
      }
      LODOP.ADD_PRINT_IMAGE("127mm","52mm","45mm","20mm",data)

      //存根区
      //顺丰logo
      LODOP.ADD_PRINT_IMAGE("150.5mm","2mm","25mm","8mm","<img src='../../static/sf_image/logo.png'/>")
      //打印顺丰电话
      LODOP.ADD_PRINT_IMAGE("159mm","2mm","20mm","8mm","<img src='../../static/sf_image/%E7%83%AD%E7%BA%BF.png'/>")

      //条码
      LODOP.ADD_PRINT_BARCODE("152mm","28mm","54mm","9mm","128A", expno);
      //子母单号打印
      if (ordtype == 1) {
          LODOP.ADD_PRINT_TEXT("163mm","30mm","10mm","5mm", no + "/" + sfzmjnum);
          LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
          LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

          if (rootno != null && rootno != "") {
              LODOP.ADD_PRINT_TEXT("163mm","30mm","20mm","5mm", "母单号：");
              LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
              LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
              LODOP.ADD_PRINT_TEXT("163mm","30mm","40mm","5mm", rootno);
              LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
              LODOP.SET_PRINT_STYLEA(0,"FontName", "Arial");
          }
      } else {
          LODOP.ADD_PRINT_TEXT("163mm","30mm","10mm","5mm", "1/1");
          LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
          LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
      }

      //产品类型
      LODOP.ADD_PRINT_TEXT("154mm","85mm","14mm","4mm","产品类型")
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7)
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体")

      //产品类型
      LODOP.ADD_PRINT_TEXT("159mm","85mm","14mm","4mm",sfexpresstype);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体")

      //寄方信息
      LODOP.ADD_PRINT_IMAGE("167.3mm","2mm","8mm","8mm","<img src='../../static/sf_image/%E5%AF%84%287mm%29.png'/>")
      LODOP.ADD_PRINT_TEXT("168mm","12mm","90mm","3mm","寄件方：" + sendername + "  " + sendertel)
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8)
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体")
      LODOP.ADD_PRINT_TEXT("171.5mm","12mm","90mm","5mm",senderaddr1 + "  " + senderaddr2);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体")

      //收方信息
      LODOP.ADD_PRINT_IMAGE("176.5mm","2mm","8mm","8mm","<img src='../../static/sf_image/%E6%94%B6%EF%BC%887mm%EF%BC%89.png'/>")
      LODOP.ADD_PRINT_TEXT("177mm","12mm","90mm","3mm",receivername + "  " + receivertel)
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8)
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体")
      LODOP.ADD_PRINT_TEXT("180.5mm","12mm","90mm","4mm",receiveraddr1 + "  " + receiveraddr2)
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8)
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体")

      //托寄物
      LODOP.ADD_PRINT_TEXT("186mm","3mm","38mm","11mm", "托寄物：" + expcontent);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");

      //付款方式
      LODOP.ADD_PRINT_TEXT("198.5mm","2mm","33mm","5mm","付款方式:" + sfpaymethod);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

      //附加信息
      //打印费用合计
      LODOP.ADD_PRINT_TEXT("186mm","34mm","64mm","3mm","费用合计：     运费：     保价费用：     ");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

      LODOP.ADD_PRINT_TEXT("189.5mm","34mm","64mm","3mm","组装费用：    超长超重：   优惠券：     ");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

      LODOP.ADD_PRINT_TEXT("193mm","34mm","64mm","3mm","易碎件：    月结账号：     第三方地区：     ");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

      LODOP.ADD_PRINT_TEXT("196.5mm","34mm","64mm","3mm","签单返还：    计费重量：    实际重量：     ");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

      LODOP.ADD_PRINT_TEXT("200mm","34mm","64mm","3mm","长*宽*高：           代收货款金额：       ");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

      //件数
      LODOP.ADD_PRINT_TEXT("204mm","3mm","16mm","4mm","件数:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

      //计费重量
      LODOP.ADD_PRINT_TEXT("204mm","20mm","21mm","4mm","计费重量：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

      //计费重量
      LODOP.ADD_PRINT_TEXT("204mm","42mm","56mm","4mm","收件员：        收件时间：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
  }

}

function drawJdPrint(idx, expno, receivername, receivertel, othtel, content, fulladdr, expcontent, sellermemo, jdgoodstype
  , bguavalue, guavalueamount, senderaddr, sendername, sendermob, orderid, customercode, promisetimetype, changeposition,
                   transtype, showt, jdprinttype,printmemo) {

  if (jdprinttype === 1) {
    LODOP.SET_SHOW_MODE("NP_NO_RESULT",true);
    //LODOP.SET_PRINT_MODE("CATCH_PRINT_STATUS",true);//设置是否进行对后台服务的打印状态进行捕获
    LODOP.PRINT_INITA("0mm","0mm","76mm","130mm",idx+"JD打印任务" + expno);
    LODOP.SET_PRINT_PAGESIZE(0,760,1300,"");
    LODOP.NewPage();
    //绘制矩形
    LODOP.ADD_PRINT_RECT("1mm","1mm","74mm","130mm",0,1);

    //京东信息
    /*LODOP.ADD_PRINT_TEXT("6mm","3mm","37mm","2mm","950616 www.jdl.com");
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",6);*/
    //打印时间
    LODOP.ADD_PRINT_TEXT("8mm","3mm","37mm","2mm", getCurrentTime());
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",6);

    //运输方式
    transtype = content.transtype ? content.transtype : transtype
    if (transtype === 1) {
      LODOP.ADD_PRINT_TEXT("2mm","37mm","13mm","13mm", "航");
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",30);
    }
    //产品
    promisetimetype = content.promisetimetype ? getPromisetimetype(content.promisetimetype) : promisetimetype
    LODOP.ADD_PRINT_TEXT("2mm","53mm","12mm","20mm", promisetimetype);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",13);
    //包裹条形码
    LODOP.ADD_PRINT_BARCODE("16mm","4mm","68mm","12mm","128A",expno + "-1-1-");
    LODOP.SET_PRINT_STYLEA(0,"ShowBarText",0);
    //单号
    LODOP.ADD_PRINT_TEXT("28mm","4mm","30mm","4mm",expno + "-1-1-");
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
    //重量
    /*LODOP.ADD_PRINT_TEXT("28mm","65mm","10mm","4mm","1.0kg");
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",7);*/

    //分割线 ---
    LODOP.ADD_PRINT_SHAPE(1, "32mm","1mm","74mm",1,0,1,"#000000");//-线

    //始发分拣中心
    LODOP.ADD_PRINT_TEXT("32.5mm","1mm","37mm","5mm", content.sourcetsortcentername);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
    LODOP.SET_PRINT_STYLEA(0,"Bold",1);
    //始发分拣滑道、笼车号
    LODOP.ADD_PRINT_TEXT("38mm","1mm","37mm","9mm", content.originalcrosscode + "-" + content.originaltabletrolleycode);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",20);
    LODOP.SET_PRINT_STYLEA(0,"Bold",1);

    //分割线 |
    LODOP.ADD_PRINT_SHAPE(0, "32mm","37mm",1, "14mm",0,1,"#000000");//|线

    //目的分拣中心
    LODOP.ADD_PRINT_TEXT("32.5mm","38mm","37mm","5mm", content.targetsortcentername);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
    LODOP.SET_PRINT_STYLEA(0,"Bold",1);
    //目的分拣滑道、笼车号
    let targetSort = (content.destinationcrosscode ? content.destinationcrosscode : content.slideNo ? content.slideNo : "") + "-" +
      (content.destinationtabletrolleycode ? content.destinationtabletrolleycode : content.targetTabletrolleyCode ? content.targetTabletrolleyCode : '')
    LODOP.ADD_PRINT_TEXT("38mm","38mm","37mm","9mm", targetSort);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",20);
    LODOP.SET_PRINT_STYLEA(0,"Bold",1);

    //分割线 ---
    LODOP.ADD_PRINT_SHAPE(1, "46mm","1mm","74mm",1,0,1,"#000000");//-线

    //集包地

    //分割线
    LODOP.ADD_PRINT_SHAPE(0, "46mm","28mm",1, "5mm",0,1,"#000000");//|线

    //派送营业部
    LODOP.ADD_PRINT_TEXT("46.5mm","28mm","35mm","5mm", content.sitename);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",12);

    //分割线
    LODOP.ADD_PRINT_SHAPE(0, "46mm","63mm",1, "10mm",0,1,"#000000");//|线

    //路区号
    LODOP.ADD_PRINT_TEXT("47mm","65mm","11mm","10mm", content.sitename);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",20);

    //分割线
    LODOP.ADD_PRINT_SHAPE(1, "51mm","1mm","62mm",1,0,1,"#000000");//-线

    //增值服务
    if (bguavalue && bguavalue === 1) {
      LODOP.ADD_PRINT_TEXT("51.5mm","2mm","63mm","5mm", "保价：￥" + guavalueamount);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
    }

    //特殊标识

    //分割线
    LODOP.ADD_PRINT_SHAPE(1, "56mm","1mm","74mm",1,0,1,"#000000");//-线

    //付款方式

    //代收金额
    LODOP.ADD_PRINT_TEXT("56.5mm","6mm","32mm","5mm", "代收金额：");
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
    //应收金额
    LODOP.ADD_PRINT_TEXT("56.5mm","39mm","30mm","5mm", "应收金额：");
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",12);

    //分割线
    LODOP.ADD_PRINT_SHAPE(1, "61mm","1mm","74mm",1,0,1,"#000000");//-线

    //收件人信息
    LODOP.ADD_PRINT_TEXT("61.5mm","1mm","5mm","5mm", "收");
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
    LODOP.ADD_PRINT_TEXT("61.5mm","7mm","25mm","5mm", receivername);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
    LODOP.ADD_PRINT_TEXT("61.5mm","32mm","30mm","5mm", receivertel);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",12);

    //分割线
    LODOP.ADD_PRINT_SHAPE(1, "66mm","1mm","74mm",1,0,1,"#000000");//-线

    //收件人地址
    LODOP.ADD_PRINT_TEXT("66.5mm","1mm","76mm","9mm", fulladdr);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
    LODOP.SET_PRINT_STYLEA(0,"Bold",1);
    LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-5);

    //分割线
    LODOP.ADD_PRINT_SHAPE(1, "73mm","1mm","74mm",1,0,1,"#000000");//-线

    //寄件人信息
    LODOP.ADD_PRINT_TEXT("73.5mm","1mm","5mm","5mm", "寄");
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
    LODOP.ADD_PRINT_TEXT("73.5mm","7mm","10mm","5mm", sendername);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",6);
    LODOP.ADD_PRINT_TEXT("73.5mm","17mm","18mm","5mm", sendermob);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",6);
    LODOP.ADD_PRINT_TEXT("73.5mm","35mm","43mm","5mm", senderaddr);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",6);
    LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);

    //分割线
    LODOP.ADD_PRINT_SHAPE(1, "78mm","1mm","74mm",1,0,1,"#000000");//-线

    //运单条形码
    LODOP.ADD_PRINT_BARCODE("79mm","3mm","48mm","9.5mm","128A",expno);
    LODOP.SET_PRINT_STYLEA(0,"ShowBarText",0);
    //运单号
    LODOP.ADD_PRINT_TEXT("88.5mm","4mm","48mm","3mm",expno);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",8);

    //T水印
    if (showt) {
      LODOP.ADD_PRINT_TEXT("79mm","65mm","15mm","18mm","T");
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",60);
      LODOP.SET_PRINT_STYLEA(0,"Alpha",150);
    }

    //分割线
    LODOP.ADD_PRINT_SHAPE(1, "91mm","1mm","74mm",1,0,1,"#000000");//-线

    //打码寄二维码
    LODOP.ADD_PRINT_IMAGE("91.5mm","1.5mm","15mm","15mm","<img src='../../static/jd_image/jdkd.png'/>")
    //扫码寄快递

    //分割线
    LODOP.ADD_PRINT_SHAPE(0, "91mm","16mm",1, "15mm",0,1,"#000000");//|线

    //托寄物
    LODOP.ADD_PRINT_TEXT("91.5mm","16mm","59mm","15mm","托寄物：" + expcontent);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
    LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);

    //分割线
    LODOP.ADD_PRINT_SHAPE(1, "106.5mm","1mm","74mm",1,0,1,"#000000");//-线

    //订单号
    LODOP.ADD_PRINT_TEXT("107mm","1mm","74mm","5mm","订单号：" + orderid);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",12);

    //分割线
    LODOP.ADD_PRINT_SHAPE(1, "111mm","1mm","74mm",1,0,1,"#000000");//-线

    //备注
    LODOP.ADD_PRINT_TEXT("112mm","1mm","74mm","20mm","备注：" + sellermemo);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
    LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);

    //目的地分拣水印
    if (content.coverCode) {
      LODOP.ADD_PRINT_TEXT("107mm","51mm","25mm","13mm",content.coverCode);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",30);
      LODOP.SET_PRINT_STYLEA(0,"Alpha",150);
    }

  } else {
    LODOP.SET_SHOW_MODE("NP_NO_RESULT",true);
    //LODOP.SET_PRINT_MODE("CATCH_PRINT_STATUS",true);//设置是否进行对后台服务的打印状态进行捕获
    LODOP.PRINT_INITA("0mm","0mm","100mm","113mm",idx+"JD打印任务" + expno);
    LODOP.SET_PRINT_PAGESIZE(0,1000,1130,"");
    LODOP.NewPage();
    if (othtel != null && othtel != "" && othtel != receivertel) {
      receivertel = receivertel + " " + othtel;
    }
    //LODOP.ADD_PRINT_SETUP_BKIMG("<%=path%>/libs/images/expimg/jd.jpg");
    //LODOP.SET_SHOW_MODE("BKIMG_WIDTH", "100mm");
    //LODOP.SET_SHOW_MODE("BKIMG_HEIGHT", "113mm");
    LODOP.ADD_PRINT_RECT("4mm","1mm","96mm","50mm",0,1);
    LODOP.ADD_PRINT_SHAPE(1, "20mm","1mm","96mm",1,0,1,"#000000");//-线
    LODOP.ADD_PRINT_SHAPE(1, "30mm","1mm","96mm",1,0,1,"#000000");
    LODOP.ADD_PRINT_SHAPE(1, "37mm","1mm","96mm",1,0,1,"#000000");
    LODOP.ADD_PRINT_SHAPE(1, "46mm","61mm","35mm",1,0,1,"#000000");

    LODOP.ADD_PRINT_SHAPE(0, "30mm","8mm",1, "24mm",0,1,"#000000");//|线
    LODOP.ADD_PRINT_SHAPE(0, "20mm","51mm",1, "17mm",0,1,"#000000");//|线
    LODOP.ADD_PRINT_SHAPE(0, "30mm","61mm",1, "24mm",0,1,"#000000");//|线
    LODOP.ADD_PRINT_SHAPE(0, "37mm","71mm",1, "17mm",0,1,"#000000");//|线

    LODOP.ADD_PRINT_BARCODE("5mm","15mm","65mm","14mm","128A",expno + "-1-1-");
    //LODOP.ADD_PRINT_TEXT("15mm","80mm","20mm","5mm","0.0kg");
    //LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    //LODOP.SET_PRINT_STYLEA(0,"FontSize", 9);

    LODOP.ADD_PRINT_TEXT("20mm","1.5mm","18mm","5mm","始发地：");
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
    LODOP.ADD_PRINT_TEXT("20mm","14mm","33mm","5mm",content.sourcetsortcentername);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
    LODOP.ADD_PRINT_TEXT("23mm","14mm","40mm","8mm",content.originalcrosscode + "-" + content.originaltabletrolleycode);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",20);

    LODOP.ADD_PRINT_TEXT("20mm","51.5mm","18mm","5mm","目的地：");
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
    LODOP.ADD_PRINT_TEXT("20mm","64mm","33mm","5mm",content.targetsortcentername);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",8);

    let targetSort = (content.destinationcrosscode ? content.destinationcrosscode : content.slideNo ? content.slideNo : "") + "-" + (content.destinationtabletrolleycode ? content.destinationtabletrolleycode : content.targetTabletrolleyCode ? content.targetTabletrolleyCode : '')
    LODOP.ADD_PRINT_TEXT("23mm","60mm","40mm","8mm",targetSort);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",20);

    LODOP.ADD_PRINT_TEXT("31mm","10mm","40mm","7mm",content.sitename);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",16);

    LODOP.ADD_PRINT_TEXT("31mm","52mm","9mm","7mm",content.road);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",16);

    LODOP.ADD_PRINT_TEXT("31mm","65mm","30mm","7mm","1/1");
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",16);

    LODOP.ADD_PRINT_TEXT("37.5mm","2mm","8mm","17mm","客户信息");
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
    LODOP.SET_PRINT_STYLEA(0,"Vorient",1);
    LODOP.ADD_PRINT_TEXT("38.5mm","10mm","40mm","13mm",fulladdr);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",9);

    LODOP.ADD_PRINT_TEXT("50mm","10mm","30mm","5mm",receivername);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
    LODOP.ADD_PRINT_TEXT("50mm","25mm","45mm","5mm", receivertel);
    LODOP.SET_PRINT_STYLEA(0,"FontName","Arial");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",7);

    LODOP.ADD_PRINT_TEXT("37.5mm","62mm","9mm","9mm","客户签字");
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
    LODOP.SET_PRINT_STYLEA(0,"Vorient",1);

    LODOP.ADD_PRINT_TEXT("46.5mm","62mm","9mm","8mm","应收金额");
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
    LODOP.SET_PRINT_STYLEA(0,"Vorient",1);
    //LODOP.ADD_PRINT_TEXT("54mm","71mm","25mm","8mm","￥ 0.0元");
    //LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    //LODOP.SET_PRINT_STYLEA(0,"FontSize",10);

    LODOP.ADD_PRINT_TEXT("54.5mm","50mm","40mm","4mm","打印日期：" + formatDate(new Date()));
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",6);

    //--------------------------------------------------------
    LODOP.ADD_PRINT_RECT("57mm","1mm","96mm","50mm",0,1);
    LODOP.ADD_PRINT_SHAPE(1, "62mm","1mm","96mm",1,0,1,"#000000");//-线
    LODOP.ADD_PRINT_SHAPE(1, "79mm","1mm","96mm",1,0,1,"#000000");
    LODOP.ADD_PRINT_SHAPE(1, "86mm","1mm","96mm",1,0,1,"#000000");
    LODOP.ADD_PRINT_SHAPE(1, "101mm","1mm","96mm",1,0,1,"#000000");

    LODOP.ADD_PRINT_SHAPE(0, "62mm","63mm",1, "45mm",0,1,"#000000");//|线
    LODOP.ADD_PRINT_SHAPE(0, "79mm","31mm",1, "7mm",0,1,"#000000");//|线
    LODOP.ADD_PRINT_SHAPE(0, "79mm","85mm",1, "7mm",0,1,"#000000");//|线

    LODOP.ADD_PRINT_TEXT("58mm","30mm","50mm","4mm","运单号   " + expno);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",10);

    LODOP.ADD_PRINT_TEXT("63mm","2mm","20mm","4mm","客户信息：");
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
    LODOP.ADD_PRINT_TEXT("63mm","17mm","45mm","4mm",receivername);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
    LODOP.ADD_PRINT_TEXT("63mm","30mm","45mm","4mm", receivertel);
    LODOP.SET_PRINT_STYLEA(0,"FontName","Arial");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",7);

    LODOP.ADD_PRINT_BARCODE("67mm","5mm","50mm","10mm","128A",expno);

    // LODOP.ADD_PRINT_TEXT("63mm","64mm","30mm","5mm","备注");
    // LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    // LODOP.SET_PRINT_STYLEA(0,"FontSize",6);

    if (changeposition === 1) {
      LODOP.ADD_PRINT_TEXT("63mm","64mm","40mm","15mm","寄方信息:" + sendername + " " + sendermob + " " + senderaddr)
    } else {
      let meno ='' // 最终打印备注
      if (((sellermemo?sellermemo.length:0) + (printmemo?printmemo.length:0) )> 40) {
        sellermemo = sellermemo ? (sellermemo.substring(0,(40 - printmemo.length - 4)) + '...') : ''
      } else {
        sellermemo = sellermemo?sellermemo:''
      }
      meno = sellermemo + ' ' + (printmemo?printmemo:'')

      LODOP.ADD_PRINT_TEXT("63mm","64mm","40mm","15mm",expcontent + " 备注：" + meno);
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);
    }
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",10);

    LODOP.ADD_PRINT_TEXT("80mm","32mm","32mm","6mm",promisetimetype);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",12);

    if (bguavalue && bguavalue == 1) {
      LODOP.ADD_PRINT_TEXT("80mm","64mm","22mm","3mm", "保价：￥" + guavalueamount);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",6);
    }

    // LODOP.ADD_PRINT_TEXT("83mm","64mm","22mm","3mm", "签单返还");
    // LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    // LODOP.SET_PRINT_STYLEA(0,"FontSize",6);

    jdgoodstype = content.jdgoodstype ? getJdgoodstype(content.jdgoodstype) : jdgoodstype
    LODOP.ADD_PRINT_TEXT("80mm","86mm","15mm","6mm", jdgoodstype);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",12);

    if (changeposition === 1) {
      let meno ='' // 最终打印备注
      if (((sellermemo?sellermemo.length:0) + (printmemo?printmemo.length:0) )> 40) {
        sellermemo = sellermemo ? (sellermemo.substring(0,(40 - printmemo.length - 4)) + '...') : ''
      } else {
        sellermemo = sellermemo?sellermemo:''
      }
      meno = sellermemo + ' ' + (printmemo?printmemo:'')
      LODOP.ADD_PRINT_TEXT("87mm","2mm","70mm","15mm",expcontent + " 备注：" + meno);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);
    } else {
      LODOP.ADD_PRINT_TEXT("87mm","2mm","20mm","4mm","寄方信息");
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",6);
      LODOP.ADD_PRINT_TEXT("90mm","4mm","54mm","8mm",senderaddr);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",6);
      LODOP.ADD_PRINT_TEXT("98mm","4mm","43mm","4mm",sendername);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",6);
      LODOP.ADD_PRINT_TEXT("98mm","47mm","25mm","4mm",sendermob);
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",6);
    }

    LODOP.ADD_PRINT_TEXT("87mm","64mm","30mm","5mm","商家ID：" + customercode);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",6);

    LODOP.ADD_PRINT_TEXT("93mm","64mm","30mm","5mm","B商家订单号：" + orderid);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",6);

    LODOP.ADD_PRINT_TEXT("102mm","2mm","60mm","7mm","请您确认包裹完好 ,保留此包裹联时 ,代表您已经正常签收并确认包裹完好！");
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",5);

    LODOP.ADD_PRINT_TEXT("101.3mm","64mm","20mm","3mm","始发城市：");
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",6);
    LODOP.ADD_PRINT_TEXT("103.5mm","64mm","35mm","4mm",content.sourcetsortcentername);
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",10);

    LODOP.ADD_PRINT_TEXT("108mm","50mm","40mm","4mm","打印日期：" + formatDate(new Date()));
    LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",6);
  }
}

function drawYtPrint( ytscancode,cmpyname, sendername, sendermob, senderaddr, ytagproduct, ytaddserv,ytagencypayfee ,ytinsuranceamount ,expno, matchcode,
  paytype,receivername, receivertel, receiveraddr,  expcontent ,count ,receivercmpname,orderid ,flag , destcode){

let date = new Date();
  let seperator1 = "/";
  let seperator2 = ":";
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
      month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
  }
  let currentyear = date.getFullYear() + seperator1 + month + seperator1 + strDate;
  let currentday = date.getHours() + seperator2 + date.getMinutes() + seperator2 + date.getSeconds();
  LODOP.SET_SHOW_MODE("NP_NO_RESULT", true);
LODOP.SET_PRINT_MODE("CATCH_PRINT_STATUS",true);
LODOP.PRINT_INITA("0mm","0mm","100mm","180mm","圆通快递打印");
LODOP.SET_PRINT_PAGESIZE(0, "100mm", "180mm", "");
LODOP.NewPage();
LODOP.ADD_PRINT_TEXTA("收","123.19mm","2.06mm","7.99mm","7.12mm","收");
LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
LODOP.ADD_PRINT_TEXTA("寄","132.45mm","2.06mm","7.99mm","7.12mm","寄");
LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
LODOP.ADD_PRINT_TEXTA("寄","57.84mm","2.06mm","7.99mm","7.12mm","寄");
LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
LODOP.ADD_PRINT_TEXTA("收","43.82mm","2.06mm","7.99mm","7.12mm","收");
LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
LODOP.ADD_PRINT_RECT(0,0,"100.01mm","180mm",0,1);
LODOP.ADD_PRINT_RECT(0,0,"100.01mm","14mm",0,1);
//增值服务
if (ytaddserv != null && ytaddserv != "" && ytaddserv == "代收货款") {
  LODOP.ADD_PRINT_TEXT(7,301,53,34,ytaddserv);
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",14);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",3);
  LODOP.ADD_PRINT_TEXT(29,131,164,24,ytaddserv+":￥"+ytagencypayfee);
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",3);
} else if (ytaddserv == "保价") {
  LODOP.ADD_PRINT_TEXT(7,301,53,34,ytaddserv);
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",14);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",3);
  LODOP.ADD_PRINT_TEXT(29,131,164,24,"保价金额:￥"+ytinsuranceamount);
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",3);
} else {
  LODOP.ADD_PRINT_TEXT(7,301,53,34,ytaddserv);
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",14);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",3);
}

LODOP.ADD_PRINT_RECT("14mm",0,"100.01mm","15mm",0,1);
//三段码
LODOP.ADD_PRINT_TEXT(51,7,365,43,matchcode);
LODOP.SET_PRINT_STYLEA(0,"FontName","Arial Black");
LODOP.SET_PRINT_STYLEA(0,"FontSize",36);
LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
LODOP.ADD_PRINT_RECT("29mm",0,"100.01mm","10mm",0,1);
//支付方式
LODOP.ADD_PRINT_TEXT(120,248,100,25,paytype);
LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
//时效产品
if (destcode != null && destcode != "" && destcode == "A") {
  LODOP.ADD_PRINT_TEXT(119,20,196,26,"【A】");
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
} else {
  LODOP.ADD_PRINT_TEXT(119,20,196,26,"【"+ytagproduct+"】");
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
}

LODOP.ADD_PRINT_RECT("39mm",0,"100.01mm","15mm",0,1);
LODOP.ADD_PRINT_RECT("54mm",0,"100.01mm","12.28mm",0,1);
//一联收件信息
if (receivername != null && receivername != "") {
  LODOP.ADD_PRINT_TEXT(150,40,318,20,receivername+" "+receivertel);
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
} else {
  LODOP.ADD_PRINT_TEXT(150,40,318,20,receivercmpname+" "+receivertel);
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
}

LODOP.ADD_PRINT_TEXT(169,40,318,28,receiveraddr);
LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
LODOP.SET_PRINT_STYLEA(0,"Bold",1);
//一联寄件信息
if (sendername != null && sendername != "") {
  LODOP.ADD_PRINT_TEXT(208,40,318,20,sendername +" "+ sendermob);
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
} else {
  LODOP.ADD_PRINT_TEXT(208,40,318,20,cmpyname +" "+ sendermob);
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
}

LODOP.ADD_PRINT_TEXT(222,40,318,27,senderaddr);
LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
LODOP.ADD_PRINT_RECT("65.99mm",0,"100.01mm","22.99mm",0,1);
//运单号条形码
LODOP.ADD_PRINT_BARCODE(265,32,"94.01mm","15mm","128A",expno);
LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
LODOP.ADD_PRINT_RECT("89.01mm",0,"100.01mm","20.27mm",0,1);
LODOP.ADD_PRINT_LINE(414,0,413,"100.01mm",0,1);
LODOP.ADD_PRINT_LINE("109.01mm","20mm","89.01mm",77,0,1);
LODOP.ADD_PRINT_LINE("109.01mm","80.01mm","89.01mm",303,0,1);
//三段码 + 运单号 二维码
if (flag) {
  LODOP.ADD_PRINT_BARCODE(350,315,"20.9mm","21.7mm","QRCode",matchcode+expno);
} else {
  LODOP.ADD_PRINT_BARCODE(343,305,"18.68mm","19.86mm","QRCode",expno);
}
//快递说明
LODOP.ADD_PRINT_TEXT(342,87,211,45,"快件送达收件人地址，经收件人或收件人（寄件人）允许的代收人签字，视为送达。您的签字代表您已验收此包裹，并已确认商品信息无误、包装完好、没有划痕、破损等表面质量问题。");
LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
LODOP.SET_PRINT_STYLEA(0,"FontSize",6);
LODOP.ADD_PRINT_TEXT(398,219,52,20,"签收栏");
LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
//打印时间 计数 计重
LODOP.ADD_PRINT_TEXT(342,8,75,20,currentyear);
LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
LODOP.ADD_PRINT_TEXT(357,8,75,20,currentday);
LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
LODOP.ADD_PRINT_TEXT(376,8,75,20,"打印时间");
LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
LODOP.ADD_PRINT_TEXT(389,8,75,20,"数量：" + count );
LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
LODOP.ADD_PRINT_TEXT(401,8,75,20,"重量：");
LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
LODOP.ADD_PRINT_RECT("109.46mm",0,"100.01mm","10.8mm",0,1);
//二联中的运单号条形码
LODOP.ADD_PRINT_BARCODE(419,175,"60.01mm","7.99mm","128A",expno);
LODOP.ADD_PRINT_RECT("119.99mm",0,"100.01mm","20mm",0,1);
LODOP.ADD_PRINT_LINE("139.99mm","80.01mm","119.99mm",303,0,1);
LODOP.ADD_PRINT_LINE("130.25mm",0,491,"80.01mm",0,1);
//二联中的收件信息
if (receivername != null && receivername != "") {
  LODOP.ADD_PRINT_TEXT(455,40,257,20,receivername+" "+receivertel);
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
} else {
  LODOP.ADD_PRINT_TEXT(455,40,257,20,receivercmpname+" "+receivertel);
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
}
LODOP.ADD_PRINT_TEXT(466,40,257,24,receiveraddr);
LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
//二联中的寄件信息
if (sendername != null && sendername != "") {
  LODOP.ADD_PRINT_TEXT(493,40,257,20,sendername +" "+ sendermob);
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
} else {
  LODOP.ADD_PRINT_TEXT(493,40,257,20,cmpyname +" "+ sendermob);
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
}

LODOP.ADD_PRINT_TEXT(505,40,257,24,senderaddr);
LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
LODOP.SET_PRINT_STYLEA(0,"FontSize",7);

//客户营销二维码
if (ytscancode == null || ytscancode == "") {
  LODOP.ADD_PRINT_BARCODE(468,315,105,77,"QRCode","http://www.2wma.cn");
} else {
  LODOP.ADD_PRINT_BARCODE(468,315,105,77,"QRCode",ytscancode);
}
LODOP.ADD_PRINT_RECT("139.99mm",0,"100.01mm","35mm",0,1);
let khdm = "${session.config.khdm}";
//湖农
if (khdm != null && khdm != "" && khdm == "5658") {
  //商家自定义区
  LODOP.ADD_PRINT_TEXT(534,8,323,63,expcontent);
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.ADD_PRINT_TEXT(612,8,323,24,"大闸蟹专递 拒签死蟹不理赔");
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
} else {
  //商家自定义区
  LODOP.ADD_PRINT_TEXT(534,8,286,118,expcontent);
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
}
LODOP.ADD_PRINT_TEXT(648,293,77,20,"已验视");
//最下角的订单号
LODOP.ADD_PRINT_TEXT(667,17,157,20,"订单号：" + orderid);
LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
LODOP.SET_PRINT_STYLEA(0,"FontSize",7);
}

function drawAnPrint(destAllocateName, targetsortcentername, targetsortcenterid, receivername, receivertel, receiveraddr1, receiveraddr2,
  cmpyname, sendertel, senderaddr, expno, fourSegmentCode, expcontent){

  /**---------绘制表格---------**/
  LODOP.SET_SHOW_MODE("NP_NO_RESULT", true);
  LODOP.SET_PRINT_MODE("CATCH_PRINT_STATUS",true);//设置是否进行对后台服务的打印状态进行捕获
  //2联
  LODOP.PRINT_INITA("0.5mm","0.5mm","100mm", "180mm", "Ane打印任务");
  LODOP.SET_PRINT_PAGESIZE(0, "100mm", "180mm", "");
  LODOP.NewPage();
  //
  //-----第一栏---------------------------------------------
  let offset = 0;
  LODOP.ADD_PRINT_RECT("0mm", "0mm","100mm","110mm", 2, 1);

  LODOP.ADD_PRINT_SHAPE(1, "15mm","0mm","100mm",1,0,1,"#000000");
  LODOP.SET_PRINT_STYLEA(0,"ItemName","L1");
  LODOP.ADD_PRINT_SHAPE(1, "30mm","0mm","100mm",1,0,1,"#000000");
  LODOP.SET_PRINT_STYLEA(0,"ItemName","L2");
  LODOP.ADD_PRINT_SHAPE(1, "40mm","0mm","100mm",1,0,1,"#000000");
  LODOP.SET_PRINT_STYLEA(0,"ItemName","L3");
  LODOP.ADD_PRINT_SHAPE(1, "55mm","0mm","100mm",1,0,1,"#000000");
  LODOP.SET_PRINT_STYLEA(0,"ItemName","L4");
  LODOP.ADD_PRINT_SHAPE(1, "62mm","0mm","100mm",1,2,1,"#000000");
  LODOP.SET_PRINT_STYLEA(0,"ItemName","L5");
  LODOP.ADD_PRINT_SHAPE(1, "67mm","0mm","100mm",1,0,1,"#000000");
  LODOP.SET_PRINT_STYLEA(0,"ItemName","L6");
  LODOP.ADD_PRINT_SHAPE(1, "89mm","0mm","100mm",1,0,1,"#000000");
  LODOP.SET_PRINT_STYLEA(0,"ItemName","L7");
  LODOP.ADD_PRINT_SHAPE(1, "110mm","0mm","100mm",1,0,1,"#000000");
  LODOP.SET_PRINT_STYLEA(0,"ItemName","L8");

  LODOP.ADD_PRINT_SHAPE(0, "0mm","82mm",1, "15mm",0,1,"#000000");//|线
  LODOP.SET_PRINT_STYLEA(0,"ItemName","L21");
  LODOP.ADD_PRINT_SHAPE(0, "30mm","65mm",1,"10mm",0,1,"#000000");
  LODOP.SET_PRINT_STYLEA(0,"ItemName","L22");
  LODOP.ADD_PRINT_SHAPE(0, "89mm","20mm",1,"20.6mm",0,1,"#000000");
  LODOP.SET_PRINT_STYLEA(0,"ItemName","L23");
  LODOP.ADD_PRINT_SHAPE(0, "89mm","80mm",1,"20.6mm",0,1,"#000000");
  LODOP.SET_PRINT_STYLEA(0,"ItemName","L24");

  //LODOP.ADD_PRINT_IMAGE("2.5mm", "2mm", "29mm", "13mm", "<img src='http://presale.jhtsoft.com/publicService/7aae62581afa2.jpg'></img>");

  //普通订单
  LODOP.ADD_PRINT_TEXT("3.75mm","86.5mm","17mm","3.75mm", "普通");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",13);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
  LODOP.ADD_PRINT_TEXT("8mm","86.5mm","17mm","3.75mm", "订单");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",13);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

  //四段码
  LODOP.ADD_PRINT_TEXT("17mm","5mm","80mm","13.5mm", fourSegmentCode);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",24);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

  //集 图片
  LODOP.ADD_PRINT_IMAGE("31mm", "1mm", "8mm", "8mm", "<img src='http://presale.jhtsoft.com/publicService/7ab2ac841f6af.jpg' width=\"25\" height=\"25\"></img>");

  //集散中心
  LODOP.ADD_PRINT_TEXT("31.5mm","12mm","53mm","7mm", targetsortcentername);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

  //条形码
  //LODOP.ADD_PRINT_BARCODE("31.5mm","67mm","34mm","8mm","128C", targetsortcenterid);
  //目的地网点名称
  LODOP.ADD_PRINT_TEXT("31.5mm","67mm","34mm","8mm", destAllocateName);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

  //收 图片
  LODOP.ADD_PRINT_IMAGE("42mm", "1mm", "8mm", "16mm", "<img src='http://presale.jhtsoft.com/publicService/7ab2d81d47084.jpg' width=\"29\" height=\"32\"></img>");

  //收货人
  LODOP.ADD_PRINT_TEXT("43mm","12mm","88mm","3.3mm", receivername + " " + receivertel);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
  LODOP.ADD_PRINT_TEXT("47mm","12mm","88mm","3.3mm", receiveraddr1 + "" + receiveraddr2);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

  //寄 图片
  LODOP.ADD_PRINT_IMAGE("55.5mm", "1mm", "8mm", "6mm", "<img src='http://presale.jhtsoft.com/publicService/7ab30a497c340.jpg' width=\"23\" height=\"21\"></img>");

  //发货人
  LODOP.ADD_PRINT_TEXT("55.5mm","12mm","85mm","3.3mm", cmpyname + " " + sendertel);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
  LODOP.ADD_PRINT_TEXT("59mm","12mm","85mm","3.3mm", senderaddr);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

  //约定协议
  LODOP.ADD_PRINT_IMAGE("62.4mm", "2mm", "95mm", "4.2mm", "<img src='http://presale.jhtsoft.com/publicService/7ac500e132adb.jpg' width=\"350\"></img>");

  //运单条形码
  LODOP.ADD_PRINT_BARCODE("70mm","15mm","74mm","17mm","128C", expno);

  let date = new Date();
  let seperator1 = "/";
  let seperator2 = ":";
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
      month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
  }
  let currentyear = date.getFullYear() + seperator1 + month + seperator1 + strDate;

  let currentday = date.getHours() + seperator2 + date.getMinutes() + seperator2 + date.getSeconds();

  //寄件时间
  LODOP.ADD_PRINT_TEXT("93mm","1mm","21mm","5mm", currentyear);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

  //时分秒
  LODOP.ADD_PRINT_TEXT("100mm","1mm","20mm","5mm", currentday);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

  //签收人
  LODOP.ADD_PRINT_TEXT("93mm","23mm","20mm","9mm", "签收人：");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

  //签收时间
  LODOP.ADD_PRINT_TEXT("102mm","23mm","25mm","9mm", "签收时间：");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

  //安能二维码
  LODOP.ADD_PRINT_IMAGE("89.5mm", "80.25mm", "19mm", "19mm", "<img src='http://presale.jhtsoft.com/publicService/7ad0ed7e91119.jpg' width=\"75\"></img>");


  //--------------第二联-----------------------------------
  LODOP.ADD_PRINT_RECT("111mm", "0mm","100mm","70mm", 2, 1);

  LODOP.ADD_PRINT_SHAPE(1, "121mm","0mm","100mm",1,0,1,"#000000");
  LODOP.SET_PRINT_STYLEA(0,"ItemName","L101");
  LODOP.ADD_PRINT_SHAPE(1, "131mm","0mm","80mm",1,0,1,"#000000");
  LODOP.SET_PRINT_STYLEA(0,"ItemName","L102");
  LODOP.ADD_PRINT_SHAPE(1, "141mm","0mm","100mm",1,0,1,"#000000");
  LODOP.SET_PRINT_STYLEA(0,"ItemName","L103");
  LODOP.ADD_PRINT_SHAPE(1, "110.4mm","0mm","100mm",1,0,1,"#000000");
  LODOP.SET_PRINT_STYLEA(0,"ItemName","L104");

  LODOP.ADD_PRINT_SHAPE(0, "121mm","80mm",1, "20mm",0,1,"#000000");//|线
  LODOP.SET_PRINT_STYLEA(0,"ItemName","L121");

  //快递logo
  //LODOP.ADD_PRINT_IMAGE("112mm", "2mm", "25.897mm", "9mm", "<img src='http://presale.jhtsoft.com/publicService/7aae62581afa2.jpg' width=\"90\"></img>");

  //运单号条形码
  LODOP.ADD_PRINT_BARCODE("112mm","32mm","68mm","9mm","128C", expno);

  //收 图片
  LODOP.ADD_PRINT_IMAGE("122mm", "0.5mm", "8mm", "9mm", "<img src='http://presale.jhtsoft.com/publicService/7ab2d81d47084.jpg' width=\"29\" height=\"32\"></img>");

  //收货人
  LODOP.ADD_PRINT_TEXT("122mm","12mm","68mm","4.5mm", receivername + " " + receivertel);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
  LODOP.ADD_PRINT_TEXT("125.5mm","12mm","68mm","4.5mm", receiveraddr1 + "" + receiveraddr2);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

  //寄 图片
  LODOP.ADD_PRINT_IMAGE("132mm", "0.5mm", "8mm", "10mm", "<img src='http://presale.jhtsoft.com/publicService/7ab30a497c340.jpg' width=\"23\" height=\"21\"></img>");

  //发货人
  LODOP.ADD_PRINT_TEXT("132mm","12mm","68mm","4.5mm", cmpyname + " " + sendertel);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
  LODOP.ADD_PRINT_TEXT("135.5mm","12mm","68mm","4.5mm", senderaddr);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

  //安能二维码
  LODOP.ADD_PRINT_IMAGE("121.5mm", "80.25mm", "19mm", "19mm", "<img src='http://presale.jhtsoft.com/publicService/7ad0ed7e91119.jpg' width=\"75\"></img>");

  //商品详情
  LODOP.ADD_PRINT_TEXT("150mm","10mm","80mm","35mm", expcontent + "【已检视】");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");

  //已检视
  LODOP.ADD_PRINT_TEXT("167mm","80mm","20mm","4.5mm", "已检视");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.SET_PRINT_STYLEA(0,"FontName", "黑体");
}

function formatDate (date) {
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  return y + '-' + m + '-' + d;
}

//三联单
function drawKyPrint_1st( cmpyname, sendername, sendermob, kypaytype,kyexptype, kyinsuranceamount, kyagencypayamount, kyagencypayfee,
  kycustid,expno,destcode,receivername,receivertel,receiveraddr,sellermemo,platformmemo,expcontent,count ,expmoney,receivercmpname,printmemo){
  let newcmpyname;
  if (cmpyname.length >12) {
      newcmpyname = cmpyname.substring(0, 10)+"**";
  } else {
      newcmpyname = cmpyname;
  }
  let date = new Date();
  let seperator1 = "-";
  let seperator2 = ":";
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
      month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
  }
  let currentyear = date.getFullYear() + seperator1 + month + seperator1 + strDate;
  let currentday = date.getHours() + seperator2 + date.getMinutes();
  LODOP.SET_SHOW_MODE("NP_NO_RESULT", true);
  LODOP.SET_PRINT_MODE("CATCH_PRINT_STATUS",true);
  LODOP.PRINT_INITA("0mm","0mm","100mm","210mm","跨越速运快递打印");
  LODOP.SET_PRINT_PAGESIZE(0, "100mm", "210mm", "");
  LODOP.NewPage();
  LODOP.ADD_PRINT_TEXTA("派件员","54.93mm","2.09mm","11.43mm","5.79mm","派件员");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("收件员","54.93mm","26.67mm","11.69mm","5.79mm","收件员");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("签收时间","49.11mm","51.28mm","60.01mm","5.79mm","签收时间：        年     月     日     时     分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄件签署","54.93mm","51.81mm","14.34mm","5.79mm","寄件签署");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄方","21.33mm","2.09mm","5.61mm","5.79mm","寄\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("收方","30.85mm","2.09mm","6.4mm","5.79mm","收\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("寄方","95.67mm","2.09mm","7.46mm","5.79mm","寄\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("收方","105.46mm","2.09mm","6.4mm","5.79mm","收\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("寄方","160.76mm","2.09mm","6.67mm","5.79mm","寄\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("收方","170.55mm","2.09mm","7.46mm","5.79mm","收\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("收方签名","54.93mm","76.94mm","15.4mm","5.79mm","收方签名");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("打印时间","16.56mm","2.09mm","15.68mm","5.79mm","打印时间：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  LODOP.ADD_PRINT_TEXTA("托寄物","47.52mm","2.09mm","13.12mm","5.79mm","托寄物：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("托寄物",707,"2.09mm","13.12mm",20,"托寄物：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("托寄物",460,"2.09mm","13.12mm",20,"托寄物：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  LODOP.ADD_PRINT_TEXTA("寄件时间","24.5mm","7.41mm","70.01mm","5.79mm","寄件时间：           年     月     日     时     分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄件时间",375,"7.41mm","70.01mm",20,"寄件时间：           年     月     日     时     分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄件时间",619,"7.41mm","70.01mm",20,"寄件时间：           年     月     日     时     分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  LODOP.ADD_PRINT_TEXTA("签收时间","123.19mm","51.28mm","60.01mm","5.79mm","签收时间：        年     月     日     时     分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄件签署",606,256,"20.77mm",20,"寄件签署：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("打印时间",711,"51.28mm","15.68mm",20,"打印时间：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  LODOP.ADD_PRINT_RECT("0mm","0mm","100mm","210mm",0,1);
  LODOP.ADD_PRINT_RECT("0mm","0mm","100mm","19.26mm",0,1);
  LODOP.ADD_PRINT_RECT("19mm","0mm","100mm","19.76mm",0,1);
  LODOP.ADD_PRINT_RECT("38.5mm","0mm","100mm","25.27mm",0,1);
  LODOP.ADD_PRINT_RECT("63.5mm","0mm","100mm","29.5mm",0,1);
  LODOP.ADD_PRINT_RECT("91mm","0mm","100mm","21.76mm",0,1);
  LODOP.ADD_PRINT_RECT("112.5mm","0mm","100mm","14.5mm",0,1);
  LODOP.ADD_PRINT_RECT("127mm","0mm","100mm","29.41mm",0,1);
  LODOP.ADD_PRINT_RECT("156.3mm","0mm","100mm","21.76mm",0,1);
  LODOP.ADD_PRINT_RECT("177.8mm","0mm","100mm","14.76mm",0,1);
  LODOP.ADD_PRINT_RECT("192.3mm","0mm","100mm","17.81mm",0,1);
  LODOP.ADD_PRINT_LINE("38.6mm","65.99mm","19mm",250,0,1);
  LODOP.ADD_PRINT_LINE("38.6mm","6.01mm","19mm",24,0,1);
  LODOP.ADD_PRINT_LINE("28.52mm","0mm",107,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("46.54mm","0mm",175,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("53.53mm","0mm",201,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("46.28mm","50.01mm","63.69mm",190,0,1);
  LODOP.ADD_PRINT_LINE("63.55mm","25.35mm","53.26mm",96,0,1);
  LODOP.ADD_PRINT_LINE("63.55mm","75.01mm","53.26mm",284,0,1);
  LODOP.ADD_PRINT_LINE("103.27mm","0mm",389,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("112.5mm","6.01mm","93mm",24,0,1);
  LODOP.ADD_PRINT_LINE("112.5mm","65.99mm","93mm",250,0,1);
  LODOP.ADD_PRINT_LINE("120.52mm","0mm",456,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("127mm","50.01mm","120.58mm",190,0,1);
  LODOP.ADD_PRINT_LINE("145.1mm",0,547,"100mm",2,1,"#FF0000");
  LODOP.ADD_PRINT_LINE("79.67mm",0,300,"100mm",2,1,"#FF0000");
  LODOP.ADD_PRINT_LINE("167.83mm",0,633,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("177.8mm","6.01mm","158.3mm",24,0,1);
  LODOP.ADD_PRINT_LINE("177.8mm","65.99mm","158.3mm",250,0,1);
  LODOP.ADD_PRINT_LINE("185.84mm",0,701,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("192.35mm","50.01mm","185.5mm",190,0,1);

  //计数
  LODOP.ADD_PRINT_TEXTA("件数",150,"2.09mm","18.42mm",20,"件数："+count);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("件数",430,"2.09mm","18.42mm",20,"件数："+count);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("件数",677,"2.09mm","18.42mm",20,"件数："+count);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //运费
  LODOP.ADD_PRINT_TEXTA("运费",163,"2.09mm","18.42mm",20,"运费："+expmoney);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("运费",443,"2.09mm","18.42mm",20,"运费："+expmoney);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("运费",690,"2.09mm","18.42mm",20,"运费："+expmoney);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //计重
  LODOP.ADD_PRINT_TEXTA("计重",150,"25.21mm","18.42mm",20,"计重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("计重",430,"25.21mm","18.42mm",20,"计重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("计重",677,"25.21mm","18.42mm",20,"计重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //实重
  LODOP.ADD_PRINT_TEXTA("实重",150,"51.57mm","18.42mm",20,"实重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("实重",430,"51.57mm","18.42mm",20,"实重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("实重",677,"51.57mm","18.42mm",20,"实重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //费用合计
  LODOP.ADD_PRINT_TEXTA("费用合计",150,"71.23mm","26.54mm",20,"费用合计：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("费用合计",430,"71.23mm","26.54mm",20,"费用合计：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("费用合计",677,"71.23mm","26.54mm",20,"费用合计：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //付款方式
  LODOP.ADD_PRINT_TEXTA("付款方式",163,"20.11mm","30.24mm",20,"付款方式："+kypaytype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("付款方式",443,"20.11mm","30.24mm",20,"付款方式："+kypaytype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("付款方式",690,"20.11mm","30.24mm",20,"付款方式："+kypaytype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //月结卡号
  LODOP.ADD_PRINT_TEXTA("月结卡号",163,176,"51.41mm",20,"月结卡号："+kycustid);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("月结卡号",443,176,"51.41mm",20,"月结卡号："+kycustid);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("月结卡号",690,176,"51.41mm",20,"月结卡号："+kycustid);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //附加服务
  LODOP.ADD_PRINT_TEXTA("附加服务",245,"2.09mm","17.01mm",20,"附加服务：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("附加服务",732,"2.09mm","17.01mm",20,"附加服务：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("附加服务",486,"2.09mm","17.01mm",20,"附加服务：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //声明保价值
  if(kyinsuranceamount != null && kyinsuranceamount != "" && kyinsuranceamount>0) {
      LODOP.ADD_PRINT_TEXTA("保价声明值",245,65,"34.64mm",20,"保价声明值：￥"+kyinsuranceamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("保价声明值",486,65,"34.64mm",20,"保价声明值：￥"+kyinsuranceamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("保价声明值",732,65,"34.64mm",20,"保价声明值：￥"+kyinsuranceamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXTA("保价声明值",245,65,"34.64mm",20,"保价声明值：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("保价声明值",486,65,"34.64mm",20,"保价声明值：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("保价声明值",732,65,"34.64mm",20,"保价声明值：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  //保费
  LODOP.ADD_PRINT_TEXTA("保费",245,188,"18.69mm",20,"保费:");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("保费",486,188,"18.69mm",20,"保费：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("保费",732,188,"18.69mm",20,"保费：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //代收金额
  if(kyagencypayamount != null && kyagencypayamount != "" && kyagencypayamount>0) {
      LODOP.ADD_PRINT_TEXTA("代收金额",245,260,"27.83mm",20,"代收金额：￥"+kyagencypayamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("代收金额",486,260,"27.83mm",20,"代收金额：￥"+kyagencypayamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("代收金额",732,260,"27.83mm",20,"代收金额：￥"+kyagencypayamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXTA("代收金额",245,260,"27.83mm",20,"代收金额：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("代收金额",486,260,"27.83mm",20,"代收金额：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("代收金额",732,260,"27.83mm",20,"代收金额：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  //代收手续费
  if(kyagencypayfee != null && kyagencypayfee != "" && kyagencypayfee>0) {
      LODOP.ADD_PRINT_TEXTA("代收手续费",259,"2.09mm","28.79mm",20,"代收手续费：￥"+kyagencypayfee+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("代收手续费",500,"2.09mm","28.79mm",20,"代收手续费：￥"+kyagencypayfee+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("代收手续费",746,"2.09mm","28.79mm",20,"代收手续费：￥"+kyagencypayfee+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXTA("代收手续费",259,"2.09mm","28.79mm",20,"代收手续费：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("代收手续费",500,"2.09mm","28.79mm",20,"代收手续费：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("代收手续费",746,"2.09mm","28.79mm",20,"代收手续费：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  //签回单
  LODOP.ADD_PRINT_TEXTA("签回单",259,117,"12.01mm",20,"签回单");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("签回单",746,117,"12.01mm",20,"签回单");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("签回单",500,117,"12.01mm",20,"签回单");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //备注
  let meno ='' // 最终打印备注
  if (((sellermemo?sellermemo.length:0) + (printmemo?printmemo.length:0) )> 40) {
    sellermemo = sellermemo ? (sellermemo.substring(0,(40 - printmemo.length - 4)) + '...') : ''
  } else {
    sellermemo = sellermemo?sellermemo:''
  }
  meno = sellermemo + ' ' + (printmemo?printmemo:'')
  LODOP.ADD_PRINT_TEXTA("备注",259,159,"56.14mm",20,"备注:"+meno+platformmemo);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("备注",500,159,"56.14mm",20,"备注："+meno+platformmemo);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("备注",746,159,"56.14mm",20,"备注："+meno+platformmemo);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //打印时间
  LODOP.ADD_PRINT_TEXT("16.67mm","14.55mm","27.12mm","5.79mm",currentyear + " "+ currentday);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(711,"63.74mm","27.12mm","5.79mm",currentyear + " "+ currentday);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //条形码
  LODOP.ADD_PRINT_BARCODE("4.18mm","42.86mm","51.06mm","11.91mm","128B",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
  LODOP.ADD_PRINT_BARCODE("82.58mm","56.86mm","45.06mm","9.91mm","128B",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",9.5);
  LODOP.ADD_PRINT_BARCODE("147.88mm","56.86mm","45.06mm","9.91mm","128B",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",9.5);
  //寄件信息
  LODOP.ADD_PRINT_TEXT("20.37mm","7.41mm","57.94mm","5.82mm",newcmpyname +" "+sendername+" "+sendermob);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT("93.09mm","7.41mm","57.94mm","5.82mm",newcmpyname +" "+sendername+" "+sendermob);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT("157.65mm","7.41mm","57.94mm","5.82mm",newcmpyname +" "+sendername+" "+sendermob);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //收件
  if (receivercmpname != null && receivercmpname != "" && receivercmpname.length>0) {
      LODOP.ADD_PRINT_TEXT("29.34mm","7.41mm","57.94mm","9.79mm",receivercmpname +" "+receivername+" "+receivertel +" "+receiveraddr);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXT("104.18mm","7.41mm","57.94mm","9.79mm",receivercmpname +" "+receivername+" "+receivertel +" "+receiveraddr);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXT("168.54mm","7.41mm","57.94mm","9.79mm",receivercmpname +" "+receivername+" "+receivertel +" "+receiveraddr);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXT("29.34mm","7.41mm","57.94mm","9.79mm",receiveraddr +" "+receivername+" "+receivertel);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXT("104.18mm","7.41mm","57.94mm","9.79mm",receiveraddr +" "+receivername+" "+receivertel);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXT("168.54mm","7.41mm","57.94mm","9.79mm",receiveraddr +" "+receivername+" "+receivertel);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  //区域代码
  LODOP.ADD_PRINT_TEXT("20.37mm","65.62mm","34.4mm","8.2mm",destcode);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  //快递方式
  LODOP.ADD_PRINT_TEXT("30.43mm","65.62mm","34.4mm","8.2mm",kyexptype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.ADD_PRINT_TEXT("104.51mm","65.35mm",131,31,kyexptype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.ADD_PRINT_TEXT("169.6mm","65.35mm",131,31,kyexptype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  //托寄物文本显示
  LODOP.ADD_PRINT_TEXT(180,45,141,22,expcontent);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
  LODOP.ADD_PRINT_TEXT(460,45,141,22,expcontent);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
  LODOP.ADD_PRINT_TEXT(707,45,141,22,expcontent);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
}


//二联单
function drawKyPrint_2nd( cmpyname, sendername, sendermob, kypaytype,kyexptype, kyinsuranceamount, kyagencypayamount, kyagencypayfee,
  kycustid,expno,destcode,receivername,receivertel,receiveraddr,sellermemo,platformmemo,expcontent,count ,expmoney ,receivercmpname,printmemo){
  /*let newsendername = sendername.substring(0, 1)+"**";
  let str = sendermob.substring(3, 6)
  let newsendermob = sendermob.replace(str,"****");
  let newreceivername = receivername.substring(0, 1)+"**";
  let str = receivertel.substring(3, 6)
  let newreceivertel = receivertel.replace(str,"****");*/
  let newcmpyname;
  if (cmpyname.length >12) {
      newcmpyname = cmpyname.substring(0, 10)+"**";
  } else {
      newcmpyname = cmpyname;
  }
  let date = new Date();
  let seperator1 = "-";
  let seperator2 = ":";
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
      month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
  }
  let currentyear = date.getFullYear() + seperator1 + month + seperator1 + strDate;
  let currentday = date.getHours() + seperator2 + date.getMinutes();
  LODOP.SET_SHOW_MODE("NP_NO_RESULT", true);
  LODOP.SET_PRINT_MODE("CATCH_PRINT_STATUS",true);
  LODOP.PRINT_INITA("0mm","0mm","100mm","136mm","跨越速运快递打印");
  LODOP.SET_PRINT_PAGESIZE(0, "100mm", "136mm", "");
  LODOP.NewPage();
  LODOP.ADD_PRINT_TEXTA("派件员","59.93mm","2.09mm","11.43mm","5.79mm","派件员");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("收件员","59.93mm","26.67mm","11.69mm","5.79mm","收件员");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("签收时间","52.26mm","51.28mm","60.01mm","5.79mm","签收时间：        年     月     日     时     分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄件签署","59.93mm","51.81mm","14.34mm","5.79mm","寄件签署");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄方","21.33mm","2.09mm","5.61mm","5.79mm","寄\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("收方","30.85mm","2.09mm","6.4mm","5.79mm","收\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("收方签名","59.93mm","76.94mm","15.4mm","5.79mm","收方签名");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("打印时间","15.56mm","2.09mm","15.68mm","5.79mm","打印时间：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("托寄物","48.84mm","2.09mm","13.12mm","5.79mm","托寄物：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄件时间","24.5mm","7.41mm","70.01mm","5.79mm","寄件时间：           年     月     日     时     分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_RECT("0mm","0mm","100mm","136mm",0,1);
  LODOP.ADD_PRINT_RECT("0mm","0mm","100mm","17.99mm",0,1);
  LODOP.ADD_PRINT_RECT("17.99mm","0mm","100mm","22.25mm",0,1);
  LODOP.ADD_PRINT_RECT("40.01mm","0mm","100mm","29.26mm",0,1);
  LODOP.ADD_PRINT_RECT("69mm","0mm","100mm","31.01mm",0,1);
  LODOP.ADD_PRINT_LINE("29.26mm",0,110,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("39.95mm","6.01mm","17.99mm",24,0,1);
  LODOP.ADD_PRINT_LINE("39.95mm","65.99mm","17.99mm",250,0,1);
  LODOP.ADD_PRINT_LINE("48.26mm",0,181,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("58.26mm",0,219,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("68.95mm","50.01mm","48mm",190,0,1);
  LODOP.ADD_PRINT_LINE("68.95mm","25mm","58mm",94,0,1);
  LODOP.ADD_PRINT_LINE("68.95mm","75.01mm","58mm",284,0,1);

  //计数
  LODOP.ADD_PRINT_TEXTA("件数",156,"2.09mm","18.42mm",20,"件数："+count);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //运费
  LODOP.ADD_PRINT_TEXTA("运费",171,"2.09mm","18.42mm",20,"运费："+expmoney);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //计重
  LODOP.ADD_PRINT_TEXTA("计重",156,"25.21mm","18.42mm",20,"计重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //实重
  LODOP.ADD_PRINT_TEXTA("实重",156,"51.57mm","18.42mm",20,"实重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //费用合计
  LODOP.ADD_PRINT_TEXTA("费用合计",156,"71.23mm","26.54mm",20,"费用合计：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //付款方式
  LODOP.ADD_PRINT_TEXTA("付款方式",171,"20.11mm","30.24mm",20,"付款方式："+kypaytype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //月结卡号
  LODOP.ADD_PRINT_TEXTA("月结卡号",171,176,"51.41mm",20,"月结卡号："+kycustid);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //附加服务
  LODOP.ADD_PRINT_TEXTA("附加服务",266,"2.09mm","17.01mm",20,"附加服务：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //声明保价值

  if(kyinsuranceamount != null && kyinsuranceamount != "" && kyinsuranceamount>0) {
      LODOP.ADD_PRINT_TEXTA("保价声明值",266,65,"34.64mm",20,"保价声明值：￥"+kyinsuranceamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXTA("保价声明值",266,65,"34.64mm",20,"保价声明值：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  //保费
  LODOP.ADD_PRINT_TEXTA("保费",266,188,"18.69mm",20,"保费:");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //代收金额
  if(kyagencypayamount != null && kyagencypayamount != "" && kyagencypayamount>0) {
      LODOP.ADD_PRINT_TEXTA("代收金额",266,260,"27.83mm",20,"代收金额：￥"+kyagencypayamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXTA("代收金额",266,260,"27.83mm",20,"代收金额：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  //代收手续费
  if(kyagencypayfee != null && kyagencypayfee != "" && kyagencypayfee>0) {
      LODOP.ADD_PRINT_TEXTA("代收手续费",281,"2.09mm","28.79mm",20,"代收手续费：￥"+kyagencypayfee+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXTA("代收手续费",281,"2.09mm","28.79mm",20,"代收手续费：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  //签回单
  LODOP.ADD_PRINT_TEXTA("签回单",281,117,"12.01mm",20,"签回单");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //备注
  let meno ='' // 最终打印备注
  if (((sellermemo?sellermemo.length:0) + (printmemo?printmemo.length:0) )> 40) {
    sellermemo = sellermemo ? (sellermemo.substring(0,(40 - printmemo.length - 4)) + '...') : ''
  } else {
    sellermemo = sellermemo?sellermemo:''
  }
  meno = sellermemo + ' ' + (printmemo?printmemo:'')
  LODOP.ADD_PRINT_TEXTA("备注",281,140,"56.14mm",20,"备注:"+meno+platformmemo);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //打印时间
  LODOP.ADD_PRINT_TEXT("15.67mm","14.55mm","27.12mm","5.79mm",currentyear + " "+ currentday);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //条形码
  LODOP.ADD_PRINT_BARCODE("2.18mm","42.86mm","51.06mm","11.91mm","128B",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
  LODOP.ADD_PRINT_BARCODE("122.32mm","16.75mm","66.49mm","10mm","128B",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
  //寄件信息
  LODOP.ADD_PRINT_TEXT("20.37mm","7.41mm","57.94mm","5.82mm",newcmpyname +" "+sendername+" "+sendermob);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //收件
  if (receivercmpname != null && receivercmpname != "" && receivercmpname.length>0) {
      LODOP.ADD_PRINT_TEXT("30.68mm","7.41mm","57.94mm","9.79mm",receivercmpname +" "+receivername+" "+receivertel +" "+receiveraddr);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXT("30.68mm","7.41mm","57.94mm","9.79mm",receiveraddr +" "+receivername+" "+receivertel);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  //区域代码
  LODOP.ADD_PRINT_TEXT("20.37mm","65.62mm","34.4mm","8.2mm",destcode);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  //快递方式
  LODOP.ADD_PRINT_TEXT("31.76mm","65.62mm","34.4mm","8.2mm",kyexptype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);

  //托寄物文本显示
  LODOP.ADD_PRINT_TEXT(184,45,141,22,expcontent);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  LODOP.ADD_PRINT_TEXTA("运费","110.75mm","53.39mm","19.63mm","5.79mm","运      费：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.ADD_PRINT_TEXTA("付款方式","101.76mm","53.39mm","19.63mm","5.79mm","付款方式：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.ADD_PRINT_TEXTA("寄方","110.75mm","2.06mm","12.75mm","5.79mm","寄方：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.ADD_PRINT_TEXTA("收方","101.76mm","1.8mm","12.75mm","5.79mm","收方：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.ADD_PRINT_TEXT(402,345,28,20,"收");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  LODOP.ADD_PRINT_TEXT(416,345,28,20,"件");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(431,345,28,20,"客");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(447,345,28,20,"户");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(463,345,28,20,"存");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(478,345,28,20,"根");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  if (receivercmpname != null && receivercmpname != "" && receivercmpname.length>0) {
      LODOP.ADD_PRINT_TEXT(385,50,155,30,receivercmpname);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  } else {
      LODOP.ADD_PRINT_TEXT(385,50,155,30,receivername);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  }
  if (cmpyname != null && cmpyname != "" && cmpyname.length>0) {
      LODOP.ADD_PRINT_TEXT(419,50,155,31,cmpyname);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  } else {
      LODOP.ADD_PRINT_TEXT(419,50,155,31,sendername);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  }

  LODOP.ADD_PRINT_TEXT(385,265,84,22,kypaytype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.ADD_PRINT_TEXT(419,265,84,22,expmoney);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
}

//果鲜模板二联单
function drawKyPrint_3rd( cmpyname, sendername, sendermob, kypaytype,kyexptype, kyinsuranceamount, kyagencypayamount, kyagencypayfee,
  kycustid,expno,destcode,receivername,receivertel,receiveraddr,sellermemo,platformmemo,expcontent,count ,expmoney ,receivercmpname,
  sitename,startflight,endflight,flightno,charterno,printmemo){
  /*let newsendername = sendername.substring(0, 1)+"**";
  let str = sendermob.substring(3, 6)
  let newsendermob = sendermob.replace(str,"****");
  let newreceivername = receivername.substring(0, 1)+"**";
  let str = receivertel.substring(3, 6)
  let newreceivertel = receivertel.replace(str,"****");*/
  let newcmpyname;
  if (cmpyname.length >12) {
      newcmpyname = cmpyname.substring(0, 10)+"**";
  } else {
      newcmpyname = cmpyname;
  }
  let date = new Date();
  let seperator1 = "-";
  let seperator2 = ":";
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
      month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
  }
  let currentyear = date.getFullYear() + seperator1 + month + seperator1 + strDate;
  let currentday = date.getHours() + seperator2 + date.getMinutes();
  LODOP.SET_SHOW_MODE("NP_NO_RESULT", true);
  LODOP.SET_PRINT_MODE("CATCH_PRINT_STATUS",true);
  LODOP.PRINT_INITA("0mm","0mm","100mm","136mm","跨越速运快递打印");
  LODOP.SET_PRINT_PAGESIZE("", "100mm", "136mm", "");
  LODOP.NewPage();
  LODOP.ADD_PRINT_TEXTA("寄件签署","67.63mm","2.09mm","14.34mm","5.79mm","寄件签署");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("收件员","67.63mm","26.67mm","11.69mm","5.79mm","收件员");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("签收时间","60.48mm","51.28mm","60.01mm","5.79mm","签收时间：      年    月    日    时    分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("收方签名","67.63mm","51.81mm","14.34mm","5.79mm","收方签名");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄方","32.86mm","2.09mm","5.29mm","10.58mm","寄\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("收方","41.68mm","2.09mm","5.29mm","10.58mm","收\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("派件员","67.63mm","76.94mm","15.4mm","5.79mm","派件员");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("打印时间","15.56mm","2.09mm","15.68mm","5.79mm","打印时间：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("托寄物","58.1mm","2.09mm","13.12mm","5.79mm","托寄物：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("派送时间","36.94mm","7.41mm","90.01mm","5.79mm","派送时间：           年     月     日     时     分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_RECT(0,0,"100mm","136mm",0,1);
  LODOP.ADD_PRINT_RECT(0,0,"100mm","17.99mm",0,1);
  LODOP.ADD_PRINT_RECT("17.99mm",0,"100mm","13.26mm",0,1);
  LODOP.ADD_PRINT_RECT("31.01mm",0,"100mm","18.26mm",0,1);
  LODOP.ADD_PRINT_RECT("49mm",0,"100mm","28.5mm",0,1);

  LODOP.ADD_PRINT_LINE("24.77mm",0,93,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("30.85mm","66.49mm","17.99mm",252,0,1);
  LODOP.ADD_PRINT_LINE("40.27mm",0,151,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("48.87mm","6.01mm","31.01mm",24,0,1);
  LODOP.ADD_PRINT_LINE("57.02mm",0,216,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("66.75mm",0,251,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("77.00mm","50.01mm","57.26mm",190,0,1);
  LODOP.ADD_PRINT_LINE("77.31mm","25mm","66.46mm",95,0,1);
  LODOP.ADD_PRINT_LINE("77.31mm","75.01mm","66.46mm",284,0,1);
  LODOP.ADD_PRINT_LINE("100mm",0,378,"100mm",0,1);
  let flightinfo = "";
  if (startflight != null && startflight != "" && startflight.length>0) {
      flightinfo = flightinfo + startflight;
  }
  if (endflight != null && endflight != "" && endflight.length>0) {
      flightinfo = flightinfo +"-"+ endflight;
  }
  if (flightno != null && flightno != "" && flightno.length>0) {
      flightinfo = flightinfo +"("+ flightno +")";
  }
  if (charterno != null && charterno != "" && charterno.length>0) {
      flightinfo = flightinfo +"-"+charterno;
  }
  LODOP.ADD_PRINT_TEXT(74,6,240,22,flightinfo);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_TEXT(99,6,240,22,sitename);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_TEXT(70,252,120,22,destcode);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",18);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_TEXT(97,252,120,22,kyexptype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",15);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);

  //托寄物文本显示
  LODOP.ADD_PRINT_TEXT(220,45,141,22,expcontent);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //计数
  LODOP.ADD_PRINT_TEXTA("件数",189,"2.09mm","18.42mm",20,"件数："+count);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //运费
  LODOP.ADD_PRINT_TEXTA("运费",202,"2.09mm","18.42mm",20,"运费："+expmoney);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //实重
  LODOP.ADD_PRINT_TEXTA("实重",189,"25.21mm","18.42mm",20,"实重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //计重
  LODOP.ADD_PRINT_TEXTA("计重",189,"51.57mm","18.42mm",20,"计重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //费用合计
  LODOP.ADD_PRINT_TEXTA("费用合计",189,"71.23mm","26.54mm",20,"费用合计：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //付款方式
  LODOP.ADD_PRINT_TEXTA("付款方式",202,"20.11mm","30.24mm",20,"付款方式："+kypaytype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //月结卡号
  LODOP.ADD_PRINT_TEXTA("月结卡号",202,176,"51.41mm",20,"月结卡号："+kycustid);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //附加服务
  LODOP.ADD_PRINT_TEXTA("附加服务",297,"2.09mm","17.01mm",20,"附加服务：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //声明保价值
  if(kyinsuranceamount != null && kyinsuranceamount != "" && kyinsuranceamount>0) {
      LODOP.ADD_PRINT_TEXTA("声明价值",297,65,"34.64mm",20,"声明价值：￥"+kyinsuranceamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXTA("声明价值",297,65,"34.64mm",20,"声明价值：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  //代收款金额
  if(kyagencypayamount != null && kyagencypayamount != "" && kyagencypayamount>0) {
      LODOP.ADD_PRINT_TEXTA("代收款金额",297,188,"34.64mm",20,"代收款金额：￥"+kyagencypayamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXTA("代收款金额",297,188,"34.64mm",20,"代收款金额：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  //签回单
  LODOP.ADD_PRINT_TEXTA("签回单",297,310,"12.01mm",20,"签回单");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //备注
  let meno ='' // 最终打印备注
  if (((sellermemo?sellermemo.length:0) + (printmemo?printmemo.length:0) )> 40) {
    sellermemo = sellermemo ? (sellermemo.substring(0,(40 - printmemo.length - 4)) + '...') : ''
  } else {
    sellermemo = sellermemo?sellermemo:''
  }
  meno = sellermemo + ' ' + (printmemo?printmemo:'')
  LODOP.ADD_PRINT_TEXTA("备注说明",312,"2.09mm","92.86mm",40,"备注说明:"+meno+platformmemo);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //打印时间
  LODOP.ADD_PRINT_TEXT("15.67mm","14.55mm","27.12mm","5.79mm",currentyear + " "+ currentday);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",6);

  //条形码
  /*LODOP.ADD_PRINT_BARCODE("2.18mm","42.86mm","51.06mm","11.91mm","128C",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
  LODOP.ADD_PRINT_BARCODE("122.32mm","16.75mm","66.49mm","10mm","128C",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);*/
  LODOP.ADD_PRINT_BARCODE("2.18mm","38mm","60mm","10mm","128B",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
  LODOP.ADD_PRINT_BARCODE("122.32mm","19.75mm","60mm","10mm","128B",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
  //寄件信息
  LODOP.ADD_PRINT_TEXT("32.86mm","7.41mm","90.01mm","3.7mm",newcmpyname +" "+sendername+" "+sendermob);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //收件
  if (receivercmpname != null && receivercmpname != "" && receivercmpname.length>0) {
      LODOP.ADD_PRINT_TEXT("41.28mm","7.41mm","90.01mm","6.88mm",receivercmpname +" "+receivername+" "+receivertel +" "+receiveraddr);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXT("41.28mm","7.41mm","90.01mm","6.88mm",receiveraddr +" "+receivername+" "+receivertel);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  LODOP.ADD_PRINT_TEXTA("运费","110.75mm","53.39mm","19.63mm","5.79mm","运      费：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.ADD_PRINT_TEXTA("付款方式","101.76mm","53.39mm","19.63mm","5.79mm","付款方式：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.ADD_PRINT_TEXTA("寄方","110.75mm","2.06mm","12.75mm","5.79mm","寄方：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.ADD_PRINT_TEXTA("收方","101.76mm","1.8mm","12.75mm","5.79mm","收方：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.ADD_PRINT_TEXT(402,345,28,20,"收");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  LODOP.ADD_PRINT_TEXT(416,345,28,20,"件");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(431,345,28,20,"客");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(447,345,28,20,"户");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(463,345,28,20,"存");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(478,345,28,20,"根");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  if (receivercmpname != null && receivercmpname != "" && receivercmpname.length>0) {
      LODOP.ADD_PRINT_TEXT(385,50,155,30,receivercmpname);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  } else {
      LODOP.ADD_PRINT_TEXT(385,50,155,30,receivername);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  }
  if (cmpyname != null && cmpyname != "" && cmpyname.length>0) {
      LODOP.ADD_PRINT_TEXT(419,50,155,31,cmpyname);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  } else {
      LODOP.ADD_PRINT_TEXT(419,50,155,31,sendername);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  }

  LODOP.ADD_PRINT_TEXT(385,265,84,22,kypaytype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.ADD_PRINT_TEXT(419,265,84,22,expmoney);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
}

//果鲜三联单
function drawKyPrint_4th( cmpyname, sendername, sendermob, kypaytype,kyexptype, kyinsuranceamount, kyagencypayamount, kyagencypayfee,
  kycustid,expno,destcode,receivername,receivertel,receiveraddr,sellermemo,platformmemo,expcontent,count ,expmoney,receivercmpname,
  sitename,startflight,endflight,flightno,charterno,printmemo){
  /*let newsendername = sendername.substring(0, 1)+"**";
  let str = sendermob.substring(3, 6)
  let newsendermob = sendermob.replace(str,"****");
  let newreceivername = receivername.substring(0, 1)+"**";
  let str = receivertel.substring(3, 6)
  let newreceivertel = receivertel.replace(str,"****");*/
  let newcmpyname;
  if (cmpyname.length >12) {
      newcmpyname = cmpyname.substring(0, 10)+"**";
  } else {
      newcmpyname = cmpyname;
  }
  let date = new Date();
  let seperator1 = "-";
  let seperator2 = ":";
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
      month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
  }
  let currentyear = date.getFullYear() + seperator1 + month + seperator1 + strDate;
  let currentday = date.getHours() + seperator2 + date.getMinutes();
  LODOP.SET_SHOW_MODE("NP_NO_RESULT", true);
  LODOP.SET_PRINT_MODE("CATCH_PRINT_STATUS",true);
  LODOP.PRINT_INITA("0mm","0mm","100mm","210mm","跨越速运快递打印");
  LODOP.SET_PRINT_PAGESIZE(0, "100mm", "210mm", "");
  LODOP.NewPage();
  LODOP.ADD_PRINT_TEXTA("派件员","52.02mm","2.06mm","24.39mm","5.79mm","派件员：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("收件员","52.02mm","24.55mm","24.39mm","5.79mm","收件员：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("签收时间","48.86mm","50.75mm","60.01mm","5.79mm","签收时间：       年    月    日    时    分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄件签署","52.02mm","47.04mm","24.39mm","5.79mm","寄件签署：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄方","31.12mm","2.09mm","6.4mm","5.79mm","寄\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("收方","37.47mm","2.09mm","6.4mm","5.79mm","收\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("寄方","95.67mm","2.09mm","6.4mm","5.79mm","寄\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("收方","105.46mm","2.09mm","6.4mm","5.79mm","收\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("寄方","160.76mm","2.09mm","6.4mm","5.79mm","寄\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("收方","170.55mm","2.09mm","6.4mm","5.79mm","收\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("收件签名","52.02mm","70.94mm","24.39mm","5.79mm","收件签名：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("打印时间","44.34mm","50.75mm","15.68mm","5.79mm","打印时间：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  LODOP.ADD_PRINT_TEXTA("托寄物","44.08mm","1.27mm","14.08mm","5.79mm","托寄物：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("托寄物",707,"2.09mm","13.12mm",20,"托寄物：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("托寄物",460,"2.09mm","13.12mm",20,"托寄物：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  LODOP.ADD_PRINT_TEXTA("寄件时间",129,27,348,14,"寄件时间：           年     月     日     时     分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄件时间",375,"7.41mm","70.01mm",20,"寄件时间：           年     月     日     时     分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄件时间",619,"7.41mm","70.01mm",20,"寄件时间：           年     月     日     时     分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  LODOP.ADD_PRINT_TEXTA("签收时间","123.19mm","51.28mm","60.01mm","5.79mm","签收时间：       年    月    日    时    分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄件签署",606,256,"20.77mm",20,"寄件签署：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("打印时间",711,"51.28mm","15.68mm",20,"打印时间：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  LODOP.ADD_PRINT_RECT("0mm","0mm","100mm","210mm",0,1);
  /*LODOP.ADD_PRINT_RECT("0mm","0mm","100mm","19.26mm",0,1);
  LODOP.ADD_PRINT_RECT("19mm","0mm","100mm","19.76mm",0,1);
  LODOP.ADD_PRINT_RECT("38.5mm","0mm","100mm","25.27mm",0,1);

  LODOP.ADD_PRINT_LINE("38.6mm","65.99mm","19mm",250,0,1);
  LODOP.ADD_PRINT_LINE("38.6mm","6.01mm","19mm",24,0,1);
  LODOP.ADD_PRINT_LINE("28.52mm","0mm",107,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("46.54mm","0mm",175,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("53.53mm","0mm",201,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("46.28mm","50.01mm","63.69mm",190,0,1);
  LODOP.ADD_PRINT_LINE("63.55mm","25.35mm","53.26mm",96,0,1);
  LODOP.ADD_PRINT_LINE("63.55mm","75.01mm","53.26mm",284,0,1);*/

  LODOP.ADD_PRINT_RECT(0,0,"100mm","17.28mm",0,1);
  LODOP.ADD_PRINT_RECT("61.5mm","0mm","100mm","29.5mm",0,1);
  LODOP.ADD_PRINT_RECT("91mm","0mm","100mm","21.76mm",0,1);
  LODOP.ADD_PRINT_RECT("112.5mm","0mm","100mm","14.5mm",0,1);
  LODOP.ADD_PRINT_RECT("127mm","0mm","100mm","29.41mm",0,1);
  LODOP.ADD_PRINT_RECT("156.3mm","0mm","100mm","21.76mm",0,1);
  LODOP.ADD_PRINT_RECT("177.8mm","0mm","100mm","14.76mm",0,1);
  LODOP.ADD_PRINT_RECT("192.3mm","0mm","100mm","17.81mm",0,1);
  LODOP.ADD_PRINT_RECT("17.01mm",0,"100mm","13.26mm",0,1);
  LODOP.ADD_PRINT_RECT("30mm",0,"100mm","13.26mm",0,1);
  LODOP.ADD_PRINT_RECT("42.99mm",0,"100mm","18.49mm",0,1);

  LODOP.ADD_PRINT_LINE("23.76mm",0,89,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("30mm","75.01mm","17.01mm",284,0,1);
  LODOP.ADD_PRINT_LINE("36.78mm",0,138,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("51.28mm",0,193,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("42.86mm","6.01mm","30mm",24,0,1);
  LODOP.ADD_PRINT_LINE("50.99mm","50.01mm","42.99mm",190,0,1);
  LODOP.ADD_PRINT_LINE("47.78mm","50.01mm",180,"100mm",0,1);

  LODOP.ADD_PRINT_LINE("103.27mm","0mm",389,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("112.5mm","6.01mm","93mm",24,0,1);
  LODOP.ADD_PRINT_LINE("112.5mm","65.99mm","93mm",250,0,1);
  LODOP.ADD_PRINT_LINE("120.52mm","0mm",456,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("127mm","50.01mm","120.58mm",190,0,1);
  LODOP.ADD_PRINT_LINE("145.1mm",0,547,"100mm",2,1,"#FF0000");
  LODOP.ADD_PRINT_LINE("79.67mm",0,300,"100mm",2,1,"#FF0000");
  LODOP.ADD_PRINT_LINE("167.83mm",0,633,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("177.8mm","6.01mm","158.3mm",24,0,1);
  LODOP.ADD_PRINT_LINE("177.8mm","65.99mm","158.3mm",250,0,1);
  LODOP.ADD_PRINT_LINE("185.84mm",0,701,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("192.35mm","50.01mm","185.5mm",190,0,1);
  let flightinfo = "";
  if (startflight != null && startflight != "" && startflight.length>0) {
      flightinfo = flightinfo + startflight;
  }
  if (endflight != null && endflight != "" && endflight.length>0) {
      flightinfo = flightinfo +"-"+ endflight;
  }
  if (flightno != null && flightno != "" && flightno.length>0) {
      flightinfo = flightinfo +"("+ flightno +")";
  }
  if (charterno != null && charterno != "" && charterno.length>0) {
      flightinfo = flightinfo +"-"+charterno;
  }
  LODOP.ADD_PRINT_TEXT(71,16,257,24,flightinfo);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_TEXT(95,15,258,24,sitename);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);

  //计数
  LODOP.ADD_PRINT_TEXTA("件数",208,"2.09mm","18.42mm",20,"件数："+count);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("件数",437,"2.09mm","18.42mm",20,"件数："+count);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("件数",677,"2.09mm","18.42mm",20,"件数："+count);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //运费
  LODOP.ADD_PRINT_TEXTA("运费",221,"2.09mm","18.42mm",20,"运费："+expmoney);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  /*LODOP.ADD_PRINT_TEXTA("运费",443,"2.09mm","18.42mm",20,"运费："+expmoney);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);*/
  LODOP.ADD_PRINT_TEXTA("运费",690,"2.09mm","18.42mm",20,"运费："+expmoney);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //实重
  LODOP.ADD_PRINT_TEXTA("实重",208,"25.21mm","18.42mm",20,"实重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("实重",437,"38.21mm","18.42mm",20,"实重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("实重",677,"25.21mm","18.42mm",20,"实重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //计重
  LODOP.ADD_PRINT_TEXTA("计重",208,"51.57mm","18.42mm",20,"计重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("计重",437,"71.57mm","18.42mm",20,"计重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("计重",677,"51.57mm","18.42mm",20,"计重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //费用合计
  LODOP.ADD_PRINT_TEXTA("费用合计",208,"71.23mm","26.54mm",20,"费用合计：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  /*LODOP.ADD_PRINT_TEXTA("费用合计",430,"71.23mm","26.54mm",20,"费用合计：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);*/
  LODOP.ADD_PRINT_TEXTA("费用合计",677,"71.23mm","26.54mm",20,"费用合计：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //付款方式
  LODOP.ADD_PRINT_TEXTA("付款方式",221,"20.11mm","30.24mm",20,"付款方式："+kypaytype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  /*LODOP.ADD_PRINT_TEXTA("付款方式",443,"20.11mm","30.24mm",20,"付款方式："+kypaytype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);*/
  LODOP.ADD_PRINT_TEXTA("付款方式",690,"20.11mm","30.24mm",20,"付款方式："+kypaytype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //月结卡号
  LODOP.ADD_PRINT_TEXTA("月结卡号",221,176,"51.41mm",20,"月结卡号："+kycustid);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  /*LODOP.ADD_PRINT_TEXTA("月结卡号",443,176,"51.41mm",20,"月结卡号："+kycustid);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);*/
  LODOP.ADD_PRINT_TEXTA("月结卡号",690,176,"51.41mm",20,"月结卡号："+kycustid);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //附加服务
  LODOP.ADD_PRINT_TEXTA("附加服务",237,"2.09mm","17.01mm",20,"附加服务：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("附加服务",732,"2.09mm","17.01mm",20,"附加服务：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("附加服务",486,"2.09mm","17.01mm",20,"附加服务：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //声明保价值
  if(kyinsuranceamount != null && kyinsuranceamount != "" && kyinsuranceamount>0) {
      LODOP.ADD_PRINT_TEXTA("声明价值",237,65,"34.64mm",20,"声明价值：￥"+kyinsuranceamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("声明价值",486,65,"34.64mm",20,"声明价值：￥"+kyinsuranceamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("声明价值",732,65,"34.64mm",20,"声明价值：￥"+kyinsuranceamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXTA("声明价值",237,65,"34.64mm",20,"声明价值：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("声明价值",486,65,"34.64mm",20,"声明价值：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("声明价值",732,65,"34.64mm",20,"声明价值：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  //代收金额
  if(kyagencypayamount != null && kyagencypayamount != "" && kyagencypayamount>0) {
      LODOP.ADD_PRINT_TEXTA("代收款金额",237,188,"34.64mm",20,"代收款金额：￥"+kyagencypayamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("代收款金额",486,188,"34.64mm",20,"代收款金额：￥"+kyagencypayamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("代收款金额",732,188,"34.64mm",20,"代收款金额：￥"+kyagencypayamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXTA("代收款金额",237,188,"34.64mm",20,"代收款金额：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("代收款金额",486,188,"34.64mm",20,"代收款金额：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("代收款金额",732,188,"34.64mm",20,"代收款金额：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  //签回单
  LODOP.ADD_PRINT_TEXTA("签回单",237,310,"12.01mm",20,"签回单");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("签回单",486,310,"12.01mm",20,"签回单");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("签回单",732,310,"12.01mm",20,"签回单");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //备注
  let meno ='' // 最终打印备注
  if (((sellermemo?sellermemo.length:0) + (printmemo?printmemo.length:0) )> 40) {
    sellermemo = sellermemo ? (sellermemo.substring(0,(40 - printmemo.length - 4)) + '...') : ''
  } else {
    sellermemo = sellermemo?sellermemo:''
  }
  meno = sellermemo + ' ' + (printmemo?printmemo:'')
  LODOP.ADD_PRINT_TEXTA("备注",251,"2.09mm","92.86mm",20,"备注:"+meno+platformmemo);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("备注",500,"2.09mm","92.86mm",20,"备注："+meno+platformmemo);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("备注",746,"2.09mm","92.86mm",20,"备注："+meno+platformmemo);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //打印时间
  LODOP.ADD_PRINT_TEXT("44.45mm","64.43mm","27.12mm","3.68mm",currentyear + " "+ currentday);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(711,"63.74mm","27.12mm","5.79mm",currentyear + " "+ currentday);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //条形码
  /*LODOP.ADD_PRINT_BARCODE("3.18mm","42.86mm","51.06mm","11.91mm","128C",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
  LODOP.ADD_PRINT_BARCODE("79.58mm","56.86mm","45.06mm","9.91mm","128C",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
  LODOP.ADD_PRINT_BARCODE("144.88mm","56.86mm","45.06mm","9.91mm","128C",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",9);*/
  LODOP.ADD_PRINT_BARCODE("8.18mm","52mm","47mm","8mm","128B",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
  LODOP.ADD_PRINT_BARCODE("82.58mm","52mm","47mm","8mm","128B",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
  LODOP.ADD_PRINT_BARCODE("147.88mm","52mm","47mm","8mm","128B",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
  //寄件信息
  LODOP.ADD_PRINT_TEXT(117,27,348,14,cmpyname +" "+sendername+" "+sendermob);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT("93.09mm","7.41mm","57.94mm","5.82mm",cmpyname +" "+sendername+" "+sendermob);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT("157.65mm","7.41mm","57.94mm","5.82mm",cmpyname +" "+sendername+" "+sendermob);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //收件
  if (receivercmpname != null && receivercmpname != "" && receivercmpname.length>0) {
      LODOP.ADD_PRINT_TEXT(142,27,348,20,receivercmpname +" "+receivername+" "+receivertel +" "+receiveraddr);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXT("104.18mm","7.41mm","57.94mm","9.79mm",receivercmpname +" "+receivername+" "+receivertel +" "+receiveraddr);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXT("168.54mm","7.41mm","57.94mm","9.79mm",receivercmpname +" "+receivername+" "+receivertel +" "+receiveraddr);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXT(142,27,348,20,receiveraddr +" "+receivername+" "+receivertel);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXT("104.18mm","7.41mm","57.94mm","9.79mm",receiveraddr +" "+receivername+" "+receivertel);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXT("168.54mm","7.41mm","57.94mm","9.79mm",receiveraddr +" "+receivername+" "+receivertel);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  //区域代码
  LODOP.ADD_PRINT_TEXT(70,284,90,24,destcode);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  //快递方式
  LODOP.ADD_PRINT_TEXT(95,284,90,24,kyexptype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_TEXT("104.51mm","65.35mm",131,31,kyexptype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_TEXT("169.6mm","65.35mm",131,31,kyexptype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  //托寄物文本显示
  LODOP.ADD_PRINT_TEXT(166,45,141,22,expcontent);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(460,45,141,22,expcontent);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(707,45,141,22,expcontent);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
}

//加急模板二联单
function drawKyPrint_5th( cmpyname, sendername, sendermob, kypaytype,kyexptype, kyinsuranceamount, kyagencypayamount, kyagencypayfee,
  kycustid,expno,destcode,receivername,receivertel,receiveraddr,buyermemo,expcontent,count ,expmoney ,receivercmpname,
  sitename,startflight,endflight,flightno,charterno){
  /*let newsendername = sendername.substring(0, 1)+"**";
  let str = sendermob.substring(3, 6)
  let newsendermob = sendermob.replace(str,"****");
  let newreceivername = receivername.substring(0, 1)+"**";
  let str = receivertel.substring(3, 6)
  let newreceivertel = receivertel.replace(str,"****");*/
  let newcmpyname;
  if (cmpyname.length >12) {
      newcmpyname = cmpyname.substring(0, 10)+"**";
  } else {
      newcmpyname = cmpyname;
  }
  let date = new Date();
  let seperator1 = "-";
  let seperator2 = ":";
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
      month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
  }
  let currentyear = date.getFullYear() + seperator1 + month + seperator1 + strDate;
  let currentday = date.getHours() + seperator2 + date.getMinutes();
  LODOP.SET_SHOW_MODE("NP_NO_RESULT", true);
  LODOP.SET_PRINT_MODE("CATCH_PRINT_STATUS",true);
  LODOP.PRINT_INITA("0mm","0mm","100mm","136mm","跨越速运快递打印");
  LODOP.SET_PRINT_PAGESIZE("", "100mm", "136mm", "");
  LODOP.NewPage();
  LODOP.ADD_PRINT_TEXTA("寄件签署","67.63mm","2.09mm","14.34mm","5.79mm","寄件签署");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("收件员","67.63mm","26.67mm","11.69mm","5.79mm","收件员");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("签收时间","60.48mm","51.28mm","60.01mm","5.79mm","签收时间：      年    月    日    时    分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("收方签名","67.63mm","51.81mm","14.34mm","5.79mm","收方签名");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄方","32.86mm","2.09mm","5.29mm","10.58mm","寄\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("收方","41.68mm","2.09mm","5.29mm","10.58mm","收\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("派件员","67.63mm","76.94mm","15.4mm","5.79mm","派件员");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("打印时间","15.56mm","2.09mm","15.68mm","5.79mm","打印时间：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("托寄物","58.1mm","2.09mm","13.12mm","5.79mm","托寄物：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("派送时间","36.94mm","7.41mm","90.01mm","5.79mm","派送时间：           年     月     日     时     分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_RECT(0,0,"100mm","136mm",0,1);
  LODOP.ADD_PRINT_RECT(0,0,"100mm","17.99mm",0,1);
  LODOP.ADD_PRINT_RECT("17.99mm",0,"100mm","13.26mm",0,1);
  LODOP.ADD_PRINT_RECT("31.01mm",0,"100mm","18.26mm",0,1);
  LODOP.ADD_PRINT_RECT("49mm",0,"100mm","28.5mm",0,1);

  LODOP.ADD_PRINT_LINE("31.12mm","75.01mm","17.99mm",284,0,1);
  LODOP.ADD_PRINT_LINE("31.12mm","59mm","17.99mm",224,0,1);
  LODOP.ADD_PRINT_LINE("25.03mm","75.01mm",94,"100.01mm",0,1);
  LODOP.ADD_PRINT_LINE("25.03mm",0,94,"59mm",0,1);
  LODOP.ADD_PRINT_LINE("40.27mm",0,151,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("48.87mm","6.01mm","31.01mm",24,0,1);
  LODOP.ADD_PRINT_LINE("57.02mm",0,216,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("66.75mm",0,251,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("77.00mm","50.01mm","57.26mm",190,0,1);
  LODOP.ADD_PRINT_LINE("77.31mm","25mm","66.46mm",95,0,1);
  LODOP.ADD_PRINT_LINE("77.31mm","75.01mm","66.46mm",284,0,1);
  LODOP.ADD_PRINT_LINE("100mm",0,378,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("99.99mm","85.01mm","77.5mm",322,0,1);
  let flightinfo = "";

  if (endflight != null && endflight != "" && endflight.length>0) {
      flightinfo = flightinfo+ endflight;
  }
  if (charterno != null && charterno != "" && charterno.length>0) {
      flightinfo = flightinfo +"-"+charterno;
  }
  LODOP.ADD_PRINT_TEXT(77,221,64,43,"加急");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",20);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_TEXT(70,288,90,24,destcode);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",18);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_TEXT(99,288,90,24,kyexptype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",15);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_TEXT(99,8,213,22,sitename);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_TEXT(74,8,213,22,flightinfo);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);

  //托寄物文本显示
  LODOP.ADD_PRINT_TEXT(220,45,141,22,expcontent);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //计数
  LODOP.ADD_PRINT_TEXTA("件数",189,"2.09mm","18.42mm",20,"件数："+count);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //运费
  LODOP.ADD_PRINT_TEXTA("运费",202,"2.09mm","18.42mm",20,"运费："+expmoney);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //实重
  LODOP.ADD_PRINT_TEXTA("实重",189,"25.21mm","18.42mm",20,"实重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //计重
  LODOP.ADD_PRINT_TEXTA("计重",189,"51.57mm","18.42mm",20,"计重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //费用合计
  LODOP.ADD_PRINT_TEXTA("费用合计",189,"71.23mm","26.54mm",20,"费用合计：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //付款方式
  LODOP.ADD_PRINT_TEXTA("付款方式",202,"20.11mm","30.24mm",20,"付款方式："+kypaytype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //月结卡号
  LODOP.ADD_PRINT_TEXTA("月结卡号",202,176,"51.41mm",20,"月结卡号："+kycustid);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //附加服务
  LODOP.ADD_PRINT_TEXTA("附加服务",297,"2.09mm","17.01mm",20,"附加服务：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //声明保价值
  if(kyinsuranceamount != null && kyinsuranceamount != "" && kyinsuranceamount>0) {
      LODOP.ADD_PRINT_TEXTA("声明价值",297,62,"30.4mm",20,"声明价值：￥"+kyinsuranceamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXTA("声明价值",297,62,"30.4mm",20,"声明价值：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  //代收款金额
  if(kyagencypayamount != null && kyagencypayamount != "" && kyagencypayamount>0) {
      LODOP.ADD_PRINT_TEXTA("代收款金额",297,177,"34.64mm",20,"代收款金额：￥"+kyagencypayamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXTA("代收款金额",297,177,"34.64mm",20,"代收款金额：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  //签回单
  LODOP.ADD_PRINT_TEXTA("签回单",297,288,"11.91mm",20,"签回单");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //备注
  LODOP.ADD_PRINT_TEXTA("备注说明",312,"2.09mm","82.29mm",40,"备注说明:"+buyermemo);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //备注里面的包机号
  if (charterno != null && charterno != "") {
      LODOP.ADD_PRINT_TEXT(309,317,65,50,charterno);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",30);
      LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  }

  //打印时间
  LODOP.ADD_PRINT_TEXT("15.67mm","14.55mm","27.12mm","5.79mm",currentyear + " "+ currentday);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",6);

  //条形码
  /*LODOP.ADD_PRINT_BARCODE("2.18mm","42.86mm","51.06mm","11.91mm","128C",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
  LODOP.ADD_PRINT_BARCODE("122.32mm","16.75mm","66.49mm","10mm","128C",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);*/
  LODOP.ADD_PRINT_BARCODE("2.18mm","38mm","60mm","10mm","128B",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
  LODOP.ADD_PRINT_BARCODE("122.32mm","19.75mm","60mm","10mm","128B",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
  //寄件信息
  LODOP.ADD_PRINT_TEXT("32.86mm","7.41mm","90.01mm","3.7mm",cmpyname +" "+sendername+" "+sendermob);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //收件
  if (receivercmpname != null && receivercmpname != "" && receivercmpname.length>0) {
      LODOP.ADD_PRINT_TEXT("41.28mm","7.41mm","90.01mm","6.88mm",receivercmpname +" "+receivername+" "+receivertel +" "+receiveraddr);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXT("41.28mm","7.41mm","90.01mm","6.88mm",receiveraddr +" "+receivername+" "+receivertel);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  LODOP.ADD_PRINT_TEXTA("运费","110.75mm","53.39mm","19.63mm","5.79mm","运      费：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.ADD_PRINT_TEXTA("付款方式","101.76mm","53.39mm","19.63mm","5.79mm","付款方式：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.ADD_PRINT_TEXTA("寄方","110.75mm","2.06mm","12.75mm","5.79mm","寄方：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.ADD_PRINT_TEXTA("收方","101.76mm","1.8mm","12.75mm","5.79mm","收方：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.ADD_PRINT_TEXT(402,345,28,20,"收");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  LODOP.ADD_PRINT_TEXT(416,345,28,20,"件");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(431,345,28,20,"客");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(447,345,28,20,"户");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(463,345,28,20,"存");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(478,345,28,20,"根");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  if (receivercmpname != null && receivercmpname != "" && receivercmpname.length>0) {
      LODOP.ADD_PRINT_TEXT(385,50,155,30,receivercmpname);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  } else {
      LODOP.ADD_PRINT_TEXT(385,50,155,30,receivername);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  }
  if (cmpyname != null && cmpyname != "" && cmpyname.length>0) {
      LODOP.ADD_PRINT_TEXT(419,50,155,31,cmpyname);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  } else {
      LODOP.ADD_PRINT_TEXT(419,50,155,31,sendername);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  }

  LODOP.ADD_PRINT_TEXT(385,265,84,22,kypaytype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.ADD_PRINT_TEXT(419,265,84,22,expmoney);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
}

//加急三联单
function drawKyPrint_6th( cmpyname, sendername, sendermob, kypaytype,kyexptype, kyinsuranceamount, kyagencypayamount, kyagencypayfee,
  kycustid,expno,destcode,receivername,receivertel,receiveraddr,buyermemo,expcontent,count ,expmoney,receivercmpname,
  sitename,startflight,endflight,flightno,charterno){
  /*let newsendername = sendername.substring(0, 1)+"**";
  let str = sendermob.substring(3, 6)
  let newsendermob = sendermob.replace(str,"****");
  let newreceivername = receivername.substring(0, 1)+"**";
  let str = receivertel.substring(3, 6)
  let newreceivertel = receivertel.replace(str,"****");*/
  let newcmpyname;
  if (cmpyname.length >12) {
      newcmpyname = cmpyname.substring(0, 10)+"**";
  } else {
      newcmpyname = cmpyname;
  }
  let date = new Date();
  let seperator1 = "-";
  let seperator2 = ":";
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
      month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
  }
  let currentyear = date.getFullYear() + seperator1 + month + seperator1 + strDate;
  let currentday = date.getHours() + seperator2 + date.getMinutes();
  LODOP.SET_SHOW_MODE("NP_NO_RESULT", true);
  LODOP.SET_PRINT_MODE("CATCH_PRINT_STATUS",true);
  LODOP.PRINT_INITA("0mm","0mm","100mm","210mm","跨越速运快递打印");
  LODOP.SET_PRINT_PAGESIZE(0, "100mm", "210mm", "");
  LODOP.NewPage();
  LODOP.ADD_PRINT_TEXTA("派件员","52.02mm","2.06mm","24.39mm","5.79mm","派件员：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("收件员","52.02mm","24.55mm","24.39mm","5.79mm","收件员：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("签收时间","48.86mm","50.75mm","60.01mm","5.79mm","签收时间：       年    月    日    时    分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄件签署","52.02mm","47.04mm","24.39mm","5.79mm","寄件签署：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄方","31.12mm","2.09mm","6.4mm","5.79mm","寄\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("收方","37.47mm","2.09mm","6.4mm","5.79mm","收\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("寄方","95.67mm","2.09mm","6.4mm","5.79mm","寄\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("收方","105.46mm","2.09mm","6.4mm","5.79mm","收\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("寄方","160.76mm","2.09mm","6.4mm","5.79mm","寄\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("收方","170.55mm","2.09mm","6.4mm","5.79mm","收\r\n方");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.SET_PRINT_STYLEA(0,"LineSpacing",-3);
  LODOP.ADD_PRINT_TEXTA("收件签名","52.02mm","70.94mm","24.39mm","5.79mm","收件签名：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("打印时间","44.34mm","50.75mm","15.68mm","5.79mm","打印时间：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  LODOP.ADD_PRINT_TEXTA("托寄物","44.08mm","1.27mm","14.08mm","5.79mm","托寄物：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("托寄物",707,"2.09mm","13.12mm",20,"托寄物：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("托寄物",460,"2.09mm","13.12mm",20,"托寄物：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  LODOP.ADD_PRINT_TEXTA("寄件时间","129mm",27,348,14,"寄件时间：           年     月     日     时     分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄件时间","377mm","7.41mm","70.01mm",20,"寄件时间：           年     月     日     时     分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄件时间","621mm","7.41mm","70.01mm",20,"寄件时间：           年     月     日     时     分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  LODOP.ADD_PRINT_TEXTA("签收时间","123.19mm","51.28mm","60.01mm","5.79mm","签收时间：       年    月    日    时    分");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("寄件签署",606,256,"20.77mm",20,"寄件签署：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("打印时间",711,"51.28mm","15.68mm",20,"打印时间：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  LODOP.ADD_PRINT_RECT("0mm","0mm","100mm","210mm",0,1);
  /*LODOP.ADD_PRINT_RECT("0mm","0mm","100mm","19.26mm",0,1);
  LODOP.ADD_PRINT_RECT("19mm","0mm","100mm","19.76mm",0,1);
  LODOP.ADD_PRINT_RECT("38.5mm","0mm","100mm","25.27mm",0,1);

  LODOP.ADD_PRINT_LINE("38.6mm","65.99mm","19mm",250,0,1);
  LODOP.ADD_PRINT_LINE("38.6mm","6.01mm","19mm",24,0,1);
  LODOP.ADD_PRINT_LINE("28.52mm","0mm",107,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("46.54mm","0mm",175,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("53.53mm","0mm",201,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("46.28mm","50.01mm","63.69mm",190,0,1);
  LODOP.ADD_PRINT_LINE("63.55mm","25.35mm","53.26mm",96,0,1);
  LODOP.ADD_PRINT_LINE("63.55mm","75.01mm","53.26mm",284,0,1);*/

  LODOP.ADD_PRINT_RECT(0,0,"100mm","17.28mm",0,1);
  LODOP.ADD_PRINT_RECT("61.5mm","0mm","100mm","29.5mm",0,1);
  LODOP.ADD_PRINT_RECT("91mm","0mm","100mm","21.76mm",0,1);
  LODOP.ADD_PRINT_RECT("112.5mm","0mm","100mm","14.5mm",0,1);
  LODOP.ADD_PRINT_RECT("127mm","0mm","100mm","29.41mm",0,1);
  LODOP.ADD_PRINT_RECT("156.3mm","0mm","100mm","21.76mm",0,1);
  LODOP.ADD_PRINT_RECT("177.8mm","0mm","100mm","14.76mm",0,1);
  LODOP.ADD_PRINT_RECT("192.3mm","0mm","100mm","17.81mm",0,1);
  LODOP.ADD_PRINT_RECT("17.01mm",0,"100mm","13.26mm",0,1);
  LODOP.ADD_PRINT_RECT("30mm",0,"100mm","13.26mm",0,1);
  LODOP.ADD_PRINT_RECT("42.99mm",0,"100mm","18.49mm",0,1);

  //LODOP.ADD_PRINT_LINE("23.76mm",0,89,"100mm",0,1);
  //LODOP.ADD_PRINT_LINE("30mm","75.01mm","16.86mm",284,0,1);
  LODOP.ADD_PRINT_LINE("24.02mm",0,90,"59mm",0,1);
  LODOP.ADD_PRINT_LINE("24.02mm","75.01mm",90,"100.01mm",0,1);
  LODOP.ADD_PRINT_LINE("30mm","59mm","17.01mm",224,0,1);
  LODOP.ADD_PRINT_LINE("30mm","75.01mm","17.01mm",284,0,1);
  LODOP.ADD_PRINT_LINE("77.5mm","85.01mm","61.49mm",322,0,1);
  LODOP.ADD_PRINT_LINE("36.78mm",0,138,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("51.28mm",0,193,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("42.86mm","6.01mm","30mm",24,0,1);
  LODOP.ADD_PRINT_LINE("50.99mm","50.01mm","42.99mm",190,0,1);
  LODOP.ADD_PRINT_LINE("47.78mm","50.01mm",180,"100mm",0,1);

  LODOP.ADD_PRINT_LINE("103.27mm","0mm",389,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("112.5mm","6.01mm","93mm",24,0,1);
  LODOP.ADD_PRINT_LINE("112.5mm","65.99mm","93mm",250,0,1);
  LODOP.ADD_PRINT_LINE("120.52mm","0mm",456,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("127mm","50.01mm","120.58mm",190,0,1);
  LODOP.ADD_PRINT_LINE("145.1mm",0,547,"100mm",2,1,"#FF0000");
  LODOP.ADD_PRINT_LINE("79.67mm",0,300,"100mm",2,1,"#FF0000");
  LODOP.ADD_PRINT_LINE("167.83mm",0,633,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("177.8mm","6.01mm","158.3mm",24,0,1);
  LODOP.ADD_PRINT_LINE("177.8mm","65.99mm","158.3mm",250,0,1);
  LODOP.ADD_PRINT_LINE("185.84mm",0,701,"100mm",0,1);
  LODOP.ADD_PRINT_LINE("192.35mm","50.01mm","185.5mm",190,0,1);
  let flightinfo = "";

  if (endflight != null && endflight != "" && endflight.length>0) {
      flightinfo = flightinfo + endflight;
  }
  if (charterno != null && charterno != "" && charterno.length>0) {
      flightinfo = flightinfo +"-"+charterno;
  }
  LODOP.ADD_PRINT_TEXT(96,8,213,22,sitename);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_TEXT(71,8,213,22,flightinfo);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_TEXT(71,221,64,43,"加急");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",20);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_TEXT(66,288,90,24,destcode);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",18);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_TEXT(92,288,90,24,kyexptype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",15);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);

  //备注里面的包机号
  if (charterno != null && charterno != "") {
      LODOP.ADD_PRINT_TEXT(241,317,65,50,charterno);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",30);
      LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
      LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  }
  //计数
  LODOP.ADD_PRINT_TEXTA("件数",208,"2.09mm","18.42mm",20,"件数："+count);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("件数",437,"2.09mm","18.42mm",20,"件数："+count);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("件数",677,"2.09mm","18.42mm",20,"件数："+count);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //运费
  LODOP.ADD_PRINT_TEXTA("运费",221,"2.09mm","18.42mm",20,"运费："+expmoney);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  /*LODOP.ADD_PRINT_TEXTA("运费",443,"2.09mm","18.42mm",20,"运费："+expmoney);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);*/
  LODOP.ADD_PRINT_TEXTA("运费",690,"2.09mm","18.42mm",20,"运费："+expmoney);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //实重
  LODOP.ADD_PRINT_TEXTA("实重",208,"25.21mm","18.42mm",20,"实重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("实重",437,"38.21mm","18.42mm",20,"实重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("实重",677,"25.21mm","18.42mm",20,"实重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //计重
  LODOP.ADD_PRINT_TEXTA("计重",208,"51.57mm","18.42mm",20,"计重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("计重",437,"71.57mm","18.42mm",20,"计重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("计重",677,"51.57mm","18.42mm",20,"计重：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //费用合计
  LODOP.ADD_PRINT_TEXTA("费用合计",208,"71.23mm","26.54mm",20,"费用合计：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  /*LODOP.ADD_PRINT_TEXTA("费用合计",430,"71.23mm","26.54mm",20,"费用合计：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);*/
  LODOP.ADD_PRINT_TEXTA("费用合计",677,"71.23mm","26.54mm",20,"费用合计：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //付款方式
  LODOP.ADD_PRINT_TEXTA("付款方式",221,"20.11mm","30.24mm",20,"付款方式："+kypaytype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  /*LODOP.ADD_PRINT_TEXTA("付款方式",443,"20.11mm","30.24mm",20,"付款方式："+kypaytype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);*/
  LODOP.ADD_PRINT_TEXTA("付款方式",690,"20.11mm","30.24mm",20,"付款方式："+kypaytype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //月结卡号
  LODOP.ADD_PRINT_TEXTA("月结卡号",221,176,"51.41mm",20,"月结卡号："+kycustid);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  /*LODOP.ADD_PRINT_TEXTA("月结卡号",443,176,"51.41mm",20,"月结卡号："+kycustid);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);*/
  LODOP.ADD_PRINT_TEXTA("月结卡号",690,176,"51.41mm",20,"月结卡号："+kycustid);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //附加服务
  LODOP.ADD_PRINT_TEXTA("附加服务",237,"2.09mm","17.01mm",20,"附加服务：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("附加服务",732,"2.09mm","17.01mm",20,"附加服务：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("附加服务",486,"2.09mm","17.01mm",20,"附加服务：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);

  //声明保价值
  if(kyinsuranceamount != null && kyinsuranceamount != "" && kyinsuranceamount>0)
  {
      LODOP.ADD_PRINT_TEXTA("声明价值",237,62,"30.4mm",20,"声明价值：￥"+kyinsuranceamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("声明价值",486,62,"30.4mm",20,"声明价值：￥"+kyinsuranceamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("声明价值",732,62,"30.4mm",20,"声明价值：￥"+kyinsuranceamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXTA("声明价值",237,62,"30.4mm",20,"声明价值：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("声明价值",486,62,"30.4mm",20,"声明价值：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("声明价值",732,62,"30.4mm",20,"声明价值：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  //代收金额
  if(kyagencypayamount != null && kyagencypayamount != "" && kyagencypayamount>0) {
      LODOP.ADD_PRINT_TEXTA("代收款金额",237,177,"34.64mm",20,"代收款金额：￥"+kyagencypayamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("代收款金额",486,177,"34.64mm",20,"代收款金额：￥"+kyagencypayamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("代收款金额",732,177,"34.64mm",20,"代收款金额：￥"+kyagencypayamount+"0");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXTA("代收款金额",237,177,"34.64mm",20,"代收款金额：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("代收款金额",486,177,"34.64mm",20,"代收款金额：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXTA("代收款金额",732,177,"34.64mm",20,"代收款金额：");
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  //签回单
  LODOP.ADD_PRINT_TEXTA("签回单",237,288,"11.91mm",20,"签回单");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("签回单",486,288,"11.91mm",20,"签回单");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("签回单",732,288,"11.91mm",20,"签回单");
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //备注
  LODOP.ADD_PRINT_TEXTA("备注",251,"2.09mm","82.29mm",40,"备注:"+buyermemo);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("备注",500,"2.09mm","82.29mm",40,"备注："+buyermemo);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXTA("备注",746,"2.09mm","82.29mm",40,"备注："+buyermemo);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //打印时间
  LODOP.ADD_PRINT_TEXT("44.45mm","64.43mm","27.12mm","3.68mm",currentyear + " "+ currentday);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(711,"63.74mm","27.12mm","5.79mm",currentyear + " "+ currentday);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //条形码
  /*LODOP.ADD_PRINT_BARCODE("3.18mm","42.86mm","51.06mm","11.91mm","128C",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
  LODOP.ADD_PRINT_BARCODE("81.58mm","56.86mm","45.06mm","9.91mm","128C",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
  LODOP.ADD_PRINT_BARCODE("146.88mm","56.86mm","45.06mm","9.91mm","128C",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",9);*/
  LODOP.ADD_PRINT_BARCODE("5.18mm","52mm","45mm","9mm","128B",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
  LODOP.ADD_PRINT_BARCODE("84.58mm","56mm","40mm","7mm","128B",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
  LODOP.ADD_PRINT_BARCODE("149.88mm","56mm","40mm","7mm","128B",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
  //寄件信息
  LODOP.ADD_PRINT_TEXT(117,27,348,14,cmpyname +" "+sendername+" "+sendermob);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT("93.09mm","7.41mm","57.94mm","5.82mm",cmpyname +" "+sendername+" "+sendermob);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT("157.65mm","7.41mm","57.94mm","5.82mm",cmpyname +" "+sendername+" "+sendermob);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  //收件
  if (receivercmpname != null && receivercmpname != "" && receivercmpname.length>0) {
      LODOP.ADD_PRINT_TEXT(142,27,348,20,receivercmpname +" "+receivername+" "+receivertel +" "+receiveraddr);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXT("104.18mm","7.41mm","57.94mm","9.79mm",receivercmpname +" "+receivername+" "+receivertel +" "+receiveraddr);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXT("168.54mm","7.41mm","57.94mm","9.79mm",receivercmpname +" "+receivername+" "+receivertel +" "+receiveraddr);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  } else {
      LODOP.ADD_PRINT_TEXT(142,27,348,20,receiveraddr +" "+receivername+" "+receivertel);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXT("104.18mm","7.41mm","57.94mm","9.79mm",receiveraddr +" "+receivername+" "+receivertel);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
      LODOP.ADD_PRINT_TEXT("168.54mm","7.41mm","57.94mm","9.79mm",receiveraddr +" "+receivername+" "+receivertel);
      LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  }

  LODOP.ADD_PRINT_TEXT("104.51mm","65.35mm",131,31,kyexptype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",15);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_TEXT("169.6mm","65.35mm",131,31,kyexptype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",15);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  //托寄物文本显示
  LODOP.ADD_PRINT_TEXT(166,45,141,22,expcontent);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(460,45,141,22,expcontent);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
  LODOP.ADD_PRINT_TEXT(707,45,141,22,expcontent);
  LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",7.5);
}

function drawCndPrint(cmpyname, sendername, sendermob, senderaddr, cndagproduct, cndaddserv,cndagencypayfee ,cndinsuranceamount ,expno, matchcode,
  paytype,receivername, receivertel, receiveraddr,  expcontent ,count ,receivercmpname,orderid ,flag , destcode, distributeCenterCode,totalfee,sellermemo,printmemo){
  var date = new Date();
  var seperator1 = "-";
  var seperator2 = ":";
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
  month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
  strDate = "0" + strDate;
  }
  var currentyear = date.getFullYear() + seperator1 + month + seperator1 + strDate;
  var currentday = (date.getHours()   <= 9 ? ("0"+date.getHours())  :date.getHours()  ) + seperator2 +
                  (date.getMinutes() <= 9 ? ("0"+date.getMinutes()):date.getMinutes()) + seperator2 +
                  (date.getSeconds() <= 9 ? ("0"+date.getSeconds()):date.getSeconds());
  if(isNaN(parseInt(count))){
  count = 1;
  }
  LODOP.ADD_PRINT_TEXTA("寄","69.51mm","4mm","6.51mm","6.51mm","寄");
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
  LODOP.ADD_PRINT_TEXTA("收","55.51mm","3.7mm","6.61mm","6.61mm","收");
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
  LODOP.ADD_PRINT_RECT(0,0,"100.01mm","180mm",0,2);
  // 	LODOP.ADD_PRINT_RECT(0,0,"100.01mm","12.49mm",0,1);
  LODOP.ADD_PRINT_RECT("27.49mm",0,"100.01mm","10mm",2,1);
  LODOP.ADD_PRINT_RECT("53.5mm",0,"100.01mm","14mm",2,1);
  //一联收件人信息
  if (receivername != null && receivername != ""){
      LODOP.ADD_PRINT_TEXT("55.35mm","12.49mm","83.5mm","5.03mm",receivername+" "+receivertel);
  }else{
      LODOP.ADD_PRINT_TEXT("55.35mm","12.49mm","83.5mm","5.03mm",receivercmpname+" "+receivertel);
  }

  LODOP.SET_PRINT_STYLEA(0,"FontName","Arial");
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_TEXT("59.8mm","12.49mm","83.5mm","9mm",receiveraddr);
  LODOP.SET_PRINT_STYLEA(0,"FontName","Arial");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);

  //一联寄件人信息
  if (sendername != null && sendername != ""){
      LODOP.ADD_PRINT_TEXT("69.35mm","12.49mm","83.5mm","5mm",sendername+" "+sendermob);
  }else{
      LODOP.ADD_PRINT_TEXT("69.35mm","12.49mm","83.5mm","5mm",cmpyname+" "+sendermob);
  }

  LODOP.SET_PRINT_STYLEA(0,"FontName","Arial");
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_TEXT("73.79mm","12.49mm","83.5mm","9mm",senderaddr);
  LODOP.SET_PRINT_STYLEA(0,"FontName","Arial");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  //一联条码：单号7900000011330
  LODOP.ADD_PRINT_BARCODE("41.04mm","30mm","54.16mm","11.03mm","128A",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
  LODOP.ADD_PRINT_LINE("109.99mm","75.01mm","91.49mm",284,2,1);
  //一联二维码： 单号+三段码 如： 123-456-789-7900000011330
  if(matchcode != null && matchcode != '' && expno != null && expno != ''){
      LODOP.ADD_PRINT_BARCODE(352,302,"23.52mm","23.26mm","QRCode",matchcode+"-"+expno);
  }

  LODOP.SET_PRINT_STYLEA(0,"QRCodeErrorLevel","H");
  LODOP.ADD_PRINT_TEXT("93.4mm",67,210,45,"快件送达收件人地址，经收件人或收件人（寄件人）允许的代收人签字，视为送达。您的签字代表您已验收此包裹，并已确认商品信息无误、包装完好、没有划痕、破损等表面质量问题。");
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",5);
  LODOP.ADD_PRINT_TEXT("93.5mm","4mm",57,20,"签收人：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
  LODOP.ADD_PRINT_LINE("27.52mm","83mm","12.41mm",315,2,1);
  LODOP.ADD_PRINT_BARCODE("16.4mm","30mm","30.96mm","10.05mm","128A",distributeCenterCode);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
  LODOP.ADD_PRINT_TEXT("29.34mm",0,"100.01mm","10mm",matchcode);
  LODOP.SET_PRINT_STYLEA(0,"FontName","Arial");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",18);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_LINE("81.49mm",0,309,"100.01mm",2,1);
  LODOP.ADD_PRINT_LINE("91.76mm",0,346,"100.01mm",2,1);
  //LODOP.ADD_PRINT_LINE("91.6mm","25mm","81.49mm",96,2,1);
  LODOP.ADD_PRINT_LINE("81.49mm","50.00mm","91.6mm",190,2,1);
  LODOP.ADD_PRINT_LINE("91.6mm","75.01mm","81.49mm",284,2,1);
  //LODOP.ADD_PRINT_LINE("120.09mm",0,454,"100.01mm",2,1);
  LODOP.ADD_PRINT_RECT("136mm",0,"100.01mm","14mm",2,1);
  LODOP.ADD_PRINT_TEXT("83.74mm","4mm","21.01mm","4.68mm","物品：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",6);
  LODOP.ADD_PRINT_TEXT("87.44mm","4mm","21.01mm",20,"数量："+count);
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",6);
  LODOP.ADD_PRINT_TEXT("83.74mm","26.99mm","22.99mm",20,"重量：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",6);
  LODOP.ADD_PRINT_TEXT("83.74mm","51.99mm","22.99mm",20,"付款方式："+paytype);
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",6);
  LODOP.ADD_PRINT_BARCODE(462,"30mm","54.16mm","11.03mm","128A",expno);
  LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
  LODOP.ADD_PRINT_TEXT("105.54mm",148,130,"5mm","打印日期："+currentyear+" "+currentday);
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",6);
  LODOP.SET_PRINT_STYLEA(0,"Alignment",3);
  LODOP.ADD_PRINT_TEXT("138.01mm","4mm","6.51mm","6.51mm","收");
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
  //LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
  //二联：收件人姓名电话
  if (receivername != null && receivername != ""){
      LODOP.ADD_PRINT_TEXT("137.85mm","12.49mm","83.5mm",20,receivername+" "+receivertel);
  }else{
      LODOP.ADD_PRINT_TEXT("137.85mm","12.49mm","83.5mm",20,receivercmpname+" "+receivertel);
  }

  LODOP.SET_PRINT_STYLEA(0,"FontName","Arial");
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_TEXT("142.29mm","12.49mm","83.5mm","9mm",receiveraddr);
  LODOP.SET_PRINT_STYLEA(0,"FontName","Arial");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_SHAPE(4,"109.51mm",0,"100.01mm","0.5mm",0,1,"#000000");
  LODOP.ADD_PRINT_LINE("164.25mm",0,620,"100.01mm",2,1);
  LODOP.ADD_PRINT_TEXT("152mm","4mm","6.51mm","6.51mm","寄");
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",11);
  //二联寄件人信息
  if (sendername != null && sendername != ""){
      LODOP.ADD_PRINT_TEXT("151.84mm","12.49mm","83.5mm",20,sendername+" "+sendermob);
  }else{
      LODOP.ADD_PRINT_TEXT("151.84mm","12.49mm","83.5mm",20,cmpyname+" "+sendermob);
  }

  LODOP.SET_PRINT_STYLEA(0,"FontName","Arial");
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  //二联寄件人地址
  LODOP.ADD_PRINT_TEXT("156.29mm","12.49mm","83.5mm","9mm",senderaddr);
  LODOP.SET_PRINT_STYLEA(0,"FontName","Arial");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
  LODOP.SET_PRINT_STYLEA(0,"Bold",1);
  LODOP.ADD_PRINT_SHAPE(4,"179.49mm",0,"100.01mm","0.5mm",0,1,"#000000");
  LODOP.ADD_PRINT_SHAPE(4,"15mm","86.49mm","10mm","10mm",0,1,"#000000");
  LODOP.ADD_PRINT_TEXT("18.28mm","85.8mm","9.79mm","5.08mm","保价");
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
  LODOP.SET_PRINT_STYLEA(0,"FontColor","#FFFFFF");
  LODOP.SET_PRINT_STYLEA(0,"Alignment",3);
  LODOP.ADD_PRINT_TEXT("83.74mm","76.99mm","22.99mm",20,"运费：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",6);

  LODOP.ADD_PRINT_TEXT("87.44mm","26.99mm","22.99mm",20,"总重量：");
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",6);

  LODOP.ADD_PRINT_TEXT("87.44mm","51.99mm","22.99mm",20,"保价:"+((totalfee == null || totalfee == '')? "":(cndinsuranceamount+"元")));

  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",6);

  LODOP.ADD_PRINT_TEXT("87.44mm","76.99mm","22.99mm",20,"合计：    元");
  LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
  LODOP.SET_PRINT_STYLEA(0,"FontSize",6);
  LODOP.ADD_PRINT_LINE("91.6mm","25.03mm","81.49mm",96,2,1);

  if(expcontent != null && expcontent != ''){
      LODOP.ADD_PRINT_TEXT("166mm","4mm","15.77mm","6.51mm","寄件信息");
      LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
      LODOP.ADD_PRINT_TEXT("166mm","21.7mm","74.88mm","9.26mm",expcontent);
      LODOP.SET_PRINT_STYLEA(0,"FontName","Arial");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",8);

      if(sellermemo != null && sellermemo != ''){
          LODOP.ADD_PRINT_TEXT("173.99mm","4mm","9.42mm","6.51mm","备注");
          LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
          let meno ='' // 最终打印备注
          if (((sellermemo?sellermemo.length:0) + (printmemo?printmemo.length:0) )> 40) {
            sellermemo = sellermemo ? (sellermemo.substring(0,(40 - printmemo.length - 4)) + '...') : ''
          } else {
            sellermemo = sellermemo?sellermemo:''
          }
          meno = sellermemo + ' ' + (printmemo?printmemo:'')
          LODOP.ADD_PRINT_TEXT("173.99mm","15.43mm","26.46mm","6.51mm",meno);
          LODOP.SET_PRINT_STYLEA(0,"FontName","Arial");
          LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
      }
  }

}

/**
* 获取当前时间 格式：yyyy-MM-dd HH:MM:SS
*/
function getCurrentTime() {
var date = new Date();//当前时间
var month = zeroFill(date.getMonth() + 1);//月
var day = zeroFill(date.getDate());//日
var hour = zeroFill(date.getHours());//时
var minute = zeroFill(date.getMinutes());//分
var second = zeroFill(date.getSeconds());//秒

//当前时间
var curTime = date.getFullYear() + "-" + month + "-" + day
  + " " + hour + ":" + minute + ":" + second;

return curTime;
}

/**
* 补零
*/
function zeroFill(i){
if (i >= 0 && i <= 9) {
  return "0" + i;
} else {
  return i;
}
}

function getJdgoodstype(jdgoodstype) {
    if(jdgoodstype === "1" || jdgoodstype === 1){
      return "普通"
    } else if(jdgoodstype === "4" || jdgoodstype === 4) {
      return "特配"
    }  else if(jdgoodstype === "3" || jdgoodstype === 3) {
      return "填仓"
    }  else if(jdgoodstype === "7" || jdgoodstype === 7) {
      return "冷藏"
    }  else if(jdgoodstype === "6" || jdgoodstype === 6) {
      return "控温"
    }  else if(jdgoodstype === "8" || jdgoodstype === 8) {
      return "冷冻"
    } else if(jdgoodstype === "9" || jdgoodstype === 9) {
      return "深冷"
    } else if(jdgoodstype === "5" || jdgoodstype === 5) {
      return "鲜活"
    }
    return ""
  }

  function getPromisetimetype(promisetimetype) {
    if(promisetimetype === "1" || promisetimetype === 1){
      return "特惠送"
    } else if(promisetimetype === "2" || promisetimetype === 2) {
      return "特快送"
    }  else if(promisetimetype === "4" || promisetimetype === 4) {
      return "城际即日"
    }else if(promisetimetype === "7" || promisetimetype === 7) {
      return "特惠送"
    } else if(promisetimetype === "8" || promisetimetype === 8) {
      return "生鲜专送"
    } else if(promisetimetype === "14" || promisetimetype === 14) {
      return "极速达"
    } else if(promisetimetype === "15" || promisetimetype === 15) {
      return "同城速配"
    } else if(promisetimetype === "16" || promisetimetype === 16) {
      return "生鲜特快"
    } else if(promisetimetype === "17" || promisetimetype === 17) {
      return "生鲜特惠"
    } else if(promisetimetype === "20" || promisetimetype === 20) {
      return "函速达"
    } else if(promisetimetype === "21" || promisetimetype === 21) {
      return "特惠包裹"
    }
    return ""
  }

export {
  drawSfPrint,
  drawJdPrint,
  drawYtPrint,
  drawAnPrint,
  drawKyPrint_1st,
  drawKyPrint_2nd,
  drawKyPrint_3rd,
  drawKyPrint_4th,
  drawKyPrint_5th,
  drawKyPrint_6th,
  drawCndPrint,
};



// WEBPACK FOOTER //
// ./src/util/print.js